import * as React from "react";
const ServiceCardNaturalLanguage = (props) => (
  <svg
    width={"100%"}
    height={"100%"}
    viewBox="0 0 1006 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.793 20V6H22.313C23.9397 6 25.2797 6.28667 26.333 6.86C27.3997 7.43333 28.1864 8.24667 28.693 9.3C29.213 10.34 29.473 11.58 29.473 13.02C29.473 14.4333 29.213 15.6667 28.693 16.72C28.1864 17.76 27.3997 18.5667 26.333 19.14C25.2797 19.7133 23.9397 20 22.313 20H17.793ZM20.193 17.96H22.193C23.4064 17.96 24.3597 17.7667 25.053 17.38C25.7597 16.98 26.2597 16.4133 26.553 15.68C26.8597 14.9333 27.013 14.0467 27.013 13.02C27.013 11.98 26.8597 11.0933 26.553 10.36C26.2597 9.61333 25.7597 9.04 25.053 8.64C24.3597 8.22667 23.4064 8.02 22.193 8.02H20.193V17.96ZM35.0965 20.24C34.2698 20.24 33.5832 20.1 33.0365 19.82C32.4898 19.54 32.0832 19.1667 31.8165 18.7C31.5498 18.2333 31.4165 17.7267 31.4165 17.18C31.4165 16.54 31.5765 15.9867 31.8965 15.52C32.2298 15.0533 32.7165 14.6933 33.3565 14.44C33.9965 14.1733 34.7832 14.04 35.7165 14.04H38.2565C38.2565 13.5067 38.1832 13.0667 38.0365 12.72C37.8898 12.36 37.6632 12.0933 37.3565 11.92C37.0498 11.7467 36.6565 11.66 36.1765 11.66C35.6298 11.66 35.1632 11.7867 34.7765 12.04C34.3898 12.28 34.1498 12.6533 34.0565 13.16H31.6965C31.7765 12.44 32.0165 11.8267 32.4165 11.32C32.8165 10.8 33.3432 10.4 33.9965 10.12C34.6632 9.82667 35.3898 9.68 36.1765 9.68C37.1232 9.68 37.9298 9.84667 38.5965 10.18C39.2632 10.5 39.7698 10.9667 40.1165 11.58C40.4765 12.18 40.6565 12.9067 40.6565 13.76V20H38.6165L38.3765 18.38C38.2432 18.6467 38.0698 18.8933 37.8565 19.12C37.6565 19.3467 37.4232 19.5467 37.1565 19.72C36.8898 19.88 36.5832 20.0067 36.2365 20.1C35.9032 20.1933 35.5232 20.24 35.0965 20.24ZM35.6365 18.34C36.0232 18.34 36.3632 18.2733 36.6565 18.14C36.9632 17.9933 37.2232 17.7933 37.4365 17.54C37.6632 17.2733 37.8365 16.98 37.9565 16.66C38.0765 16.34 38.1565 16 38.1965 15.64V15.6H35.9765C35.5098 15.6 35.1232 15.66 34.8165 15.78C34.5098 15.8867 34.2898 16.0467 34.1565 16.26C34.0232 16.4733 33.9565 16.72 33.9565 17C33.9565 17.28 34.0232 17.52 34.1565 17.72C34.2898 17.92 34.4832 18.0733 34.7365 18.18C34.9898 18.2867 35.2898 18.34 35.6365 18.34ZM47.4446 20C46.7646 20 46.1713 19.8933 45.6646 19.68C45.1713 19.4667 44.7846 19.1133 44.5046 18.62C44.2246 18.1267 44.0846 17.46 44.0846 16.62V11.94H42.3646V9.92H44.0846L44.3646 7.26H46.4846V9.92H49.2246V11.94H46.4846V16.62C46.4846 17.1267 46.5913 17.48 46.8046 17.68C47.0313 17.8667 47.4046 17.96 47.9246 17.96H49.1646V20H47.4446ZM54.8426 20.24C54.0159 20.24 53.3292 20.1 52.7826 19.82C52.2359 19.54 51.8292 19.1667 51.5626 18.7C51.2959 18.2333 51.1626 17.7267 51.1626 17.18C51.1626 16.54 51.3226 15.9867 51.6426 15.52C51.9759 15.0533 52.4626 14.6933 53.1026 14.44C53.7426 14.1733 54.5292 14.04 55.4626 14.04H58.0026C58.0026 13.5067 57.9292 13.0667 57.7826 12.72C57.6359 12.36 57.4092 12.0933 57.1026 11.92C56.7959 11.7467 56.4026 11.66 55.9226 11.66C55.3759 11.66 54.9092 11.7867 54.5226 12.04C54.1359 12.28 53.8959 12.6533 53.8026 13.16H51.4426C51.5226 12.44 51.7626 11.8267 52.1626 11.32C52.5626 10.8 53.0892 10.4 53.7426 10.12C54.4092 9.82667 55.1359 9.68 55.9226 9.68C56.8692 9.68 57.6759 9.84667 58.3426 10.18C59.0092 10.5 59.5159 10.9667 59.8626 11.58C60.2226 12.18 60.4026 12.9067 60.4026 13.76V20H58.3626L58.1226 18.38C57.9892 18.6467 57.8159 18.8933 57.6026 19.12C57.4026 19.3467 57.1692 19.5467 56.9026 19.72C56.6359 19.88 56.3292 20.0067 55.9826 20.1C55.6492 20.1933 55.2692 20.24 54.8426 20.24ZM55.3826 18.34C55.7692 18.34 56.1092 18.2733 56.4026 18.14C56.7092 17.9933 56.9692 17.7933 57.1826 17.54C57.4092 17.2733 57.5826 16.98 57.7026 16.66C57.8226 16.34 57.9026 16 57.9426 15.64V15.6H55.7226C55.2559 15.6 54.8692 15.66 54.5626 15.78C54.2559 15.8867 54.0359 16.0467 53.9026 16.26C53.7692 16.4733 53.7026 16.72 53.7026 17C53.7026 17.28 53.7692 17.52 53.9026 17.72C54.0359 17.92 54.2292 18.0733 54.4826 18.18C54.7359 18.2867 55.0359 18.34 55.3826 18.34Z"
      fill="white"
    />
    <path
      d="M222.924 20V7.94H218.804V6H229.424V7.94H225.304V20H222.924ZM230.326 20V9.92H232.466L232.686 11.8C232.926 11.36 233.226 10.9867 233.586 10.68C233.946 10.36 234.366 10.1133 234.846 9.94C235.34 9.76667 235.88 9.68 236.466 9.68V12.22H235.626C235.226 12.22 234.846 12.2733 234.486 12.38C234.126 12.4733 233.813 12.6333 233.546 12.86C233.293 13.0733 233.093 13.3733 232.946 13.76C232.8 14.1333 232.726 14.6067 232.726 15.18V20H230.326ZM241.636 20.24C240.809 20.24 240.122 20.1 239.576 19.82C239.029 19.54 238.622 19.1667 238.356 18.7C238.089 18.2333 237.956 17.7267 237.956 17.18C237.956 16.54 238.116 15.9867 238.436 15.52C238.769 15.0533 239.256 14.6933 239.896 14.44C240.536 14.1733 241.322 14.04 242.256 14.04H244.796C244.796 13.5067 244.722 13.0667 244.576 12.72C244.429 12.36 244.202 12.0933 243.896 11.92C243.589 11.7467 243.196 11.66 242.716 11.66C242.169 11.66 241.702 11.7867 241.316 12.04C240.929 12.28 240.689 12.6533 240.596 13.16H238.236C238.316 12.44 238.556 11.8267 238.956 11.32C239.356 10.8 239.882 10.4 240.536 10.12C241.202 9.82667 241.929 9.68 242.716 9.68C243.662 9.68 244.469 9.84667 245.136 10.18C245.802 10.5 246.309 10.9667 246.656 11.58C247.016 12.18 247.196 12.9067 247.196 13.76V20H245.156L244.916 18.38C244.782 18.6467 244.609 18.8933 244.396 19.12C244.196 19.3467 243.962 19.5467 243.696 19.72C243.429 19.88 243.122 20.0067 242.776 20.1C242.442 20.1933 242.062 20.24 241.636 20.24ZM242.176 18.34C242.562 18.34 242.902 18.2733 243.196 18.14C243.502 17.9933 243.762 17.7933 243.976 17.54C244.202 17.2733 244.376 16.98 244.496 16.66C244.616 16.34 244.696 16 244.736 15.64V15.6H242.516C242.049 15.6 241.662 15.66 241.356 15.78C241.049 15.8867 240.829 16.0467 240.696 16.26C240.562 16.4733 240.496 16.72 240.496 17C240.496 17.28 240.562 17.52 240.696 17.72C240.829 17.92 241.022 18.0733 241.276 18.18C241.529 18.2867 241.829 18.34 242.176 18.34ZM249.76 20V9.92H251.88L252.06 11.6C252.367 11.0133 252.807 10.5467 253.38 10.2C253.953 9.85333 254.633 9.68 255.42 9.68C256.233 9.68 256.927 9.85333 257.5 10.2C258.073 10.5333 258.513 11.0267 258.82 11.68C259.14 12.3333 259.3 13.1467 259.3 14.12V20H256.9V14.34C256.9 13.5 256.713 12.8533 256.34 12.4C255.967 11.9467 255.413 11.72 254.68 11.72C254.2 11.72 253.767 11.8333 253.38 12.06C253.007 12.2867 252.707 12.62 252.48 13.06C252.267 13.4867 252.16 14.0067 252.16 14.62V20H249.76ZM265.85 20.24C264.957 20.24 264.177 20.1 263.51 19.82C262.857 19.5267 262.337 19.1267 261.95 18.62C261.577 18.1 261.357 17.5067 261.29 16.84H263.69C263.757 17.12 263.877 17.38 264.05 17.62C264.224 17.8467 264.457 18.0267 264.75 18.16C265.057 18.2933 265.417 18.36 265.83 18.36C266.23 18.36 266.557 18.3067 266.81 18.2C267.064 18.08 267.25 17.9267 267.37 17.74C267.49 17.5533 267.55 17.3533 267.55 17.14C267.55 16.82 267.464 16.5733 267.29 16.4C267.117 16.2267 266.864 16.0933 266.53 16C266.21 15.8933 265.824 15.7933 265.37 15.7C264.89 15.6067 264.424 15.4933 263.97 15.36C263.53 15.2133 263.13 15.0333 262.77 14.82C262.424 14.6067 262.144 14.3333 261.93 14C261.73 13.6667 261.63 13.26 261.63 12.78C261.63 12.1933 261.784 11.6667 262.09 11.2C262.41 10.7333 262.864 10.3667 263.45 10.1C264.05 9.82 264.764 9.68 265.59 9.68C266.764 9.68 267.697 9.95333 268.39 10.5C269.097 11.0333 269.51 11.7867 269.63 12.76H267.35C267.284 12.3867 267.097 12.1 266.79 11.9C266.484 11.6867 266.077 11.58 265.57 11.58C265.05 11.58 264.65 11.68 264.37 11.88C264.104 12.0667 263.97 12.32 263.97 12.64C263.97 12.84 264.05 13.0267 264.21 13.2C264.384 13.36 264.63 13.5 264.95 13.62C265.27 13.7267 265.664 13.8333 266.13 13.94C266.877 14.0867 267.537 14.26 268.11 14.46C268.684 14.66 269.137 14.9533 269.47 15.34C269.804 15.7267 269.97 16.2733 269.97 16.98C269.984 17.62 269.817 18.1867 269.47 18.68C269.137 19.1733 268.664 19.56 268.05 19.84C267.437 20.1067 266.704 20.24 265.85 20.24ZM272.799 20V8.82C272.799 8.04667 272.926 7.42667 273.179 6.96C273.446 6.48 273.826 6.13333 274.319 5.92C274.812 5.70667 275.399 5.6 276.079 5.6H277.279V7.64H276.439C275.999 7.64 275.679 7.73333 275.479 7.92C275.292 8.09333 275.199 8.4 275.199 8.84V20H272.799ZM271.359 11.94V9.92H277.479V11.94H271.359ZM283.874 20.24C282.874 20.24 281.994 20.0267 281.234 19.6C280.474 19.16 279.881 18.5467 279.454 17.76C279.028 16.9733 278.814 16.0667 278.814 15.04C278.814 13.9733 279.021 13.04 279.434 12.24C279.861 11.44 280.454 10.8133 281.214 10.36C281.988 9.90667 282.881 9.68 283.894 9.68C284.881 9.68 285.741 9.9 286.474 10.34C287.208 10.78 287.774 11.3733 288.174 12.12C288.574 12.8533 288.774 13.68 288.774 14.6C288.774 14.7333 288.774 14.88 288.774 15.04C288.774 15.2 288.761 15.3667 288.734 15.54H280.534V14H286.354C286.328 13.2667 286.081 12.6933 285.614 12.28C285.148 11.8533 284.568 11.64 283.874 11.64C283.381 11.64 282.928 11.7533 282.514 11.98C282.101 12.2067 281.774 12.5467 281.534 13C281.294 13.44 281.174 14 281.174 14.68V15.26C281.174 15.8867 281.288 16.4267 281.514 16.88C281.754 17.3333 282.074 17.68 282.474 17.92C282.888 18.1467 283.348 18.26 283.854 18.26C284.414 18.26 284.874 18.14 285.234 17.9C285.608 17.66 285.881 17.34 286.054 16.94H288.494C288.308 17.5667 288.001 18.1333 287.574 18.64C287.148 19.1333 286.621 19.5267 285.994 19.82C285.368 20.1 284.661 20.24 283.874 20.24ZM290.99 20V9.92H293.13L293.35 11.8C293.59 11.36 293.89 10.9867 294.25 10.68C294.61 10.36 295.03 10.1133 295.51 9.94C296.004 9.76667 296.544 9.68 297.13 9.68V12.22H296.29C295.89 12.22 295.51 12.2733 295.15 12.38C294.79 12.4733 294.477 12.6333 294.21 12.86C293.957 13.0733 293.757 13.3733 293.61 13.76C293.464 14.1333 293.39 14.6067 293.39 15.18V20H290.99ZM308.202 20C307.522 20 306.929 19.8933 306.422 19.68C305.929 19.4667 305.542 19.1133 305.262 18.62C304.982 18.1267 304.842 17.46 304.842 16.62V11.94H303.122V9.92H304.842L305.122 7.26H307.242V9.92H309.982V11.94H307.242V16.62C307.242 17.1267 307.349 17.48 307.562 17.68C307.789 17.8667 308.162 17.96 308.682 17.96H309.922V20H308.202ZM316.686 20.24C315.726 20.24 314.86 20.02 314.086 19.58C313.326 19.1267 312.726 18.5067 312.286 17.72C311.86 16.92 311.646 16.0067 311.646 14.98C311.646 13.9267 311.866 13.0067 312.306 12.22C312.746 11.42 313.346 10.8 314.106 10.36C314.88 9.90667 315.746 9.68 316.706 9.68C317.666 9.68 318.526 9.90667 319.286 10.36C320.06 10.8 320.66 11.4133 321.086 12.2C321.526 12.9867 321.746 13.9067 321.746 14.96C321.746 16.0133 321.526 16.9333 321.086 17.72C320.646 18.5067 320.04 19.1267 319.266 19.58C318.506 20.02 317.646 20.24 316.686 20.24ZM316.686 18.18C317.166 18.18 317.6 18.06 317.986 17.82C318.386 17.58 318.706 17.22 318.946 16.74C319.186 16.26 319.306 15.6667 319.306 14.96C319.306 14.2533 319.186 13.6667 318.946 13.2C318.72 12.72 318.406 12.36 318.006 12.12C317.62 11.88 317.186 11.76 316.706 11.76C316.24 11.76 315.806 11.88 315.406 12.12C315.006 12.36 314.686 12.72 314.446 13.2C314.206 13.6667 314.086 14.2533 314.086 14.96C314.086 15.6667 314.206 16.26 314.446 16.74C314.686 17.22 315 17.58 315.386 17.82C315.786 18.06 316.22 18.18 316.686 18.18ZM238.5 46L233.36 32H235.94L239.96 43.54L244.04 32H246.58L241.42 46H238.5ZM251.755 46.24C250.755 46.24 249.875 46.0267 249.115 45.6C248.355 45.16 247.762 44.5467 247.335 43.76C246.909 42.9733 246.695 42.0667 246.695 41.04C246.695 39.9733 246.902 39.04 247.315 38.24C247.742 37.44 248.335 36.8133 249.095 36.36C249.869 35.9067 250.762 35.68 251.775 35.68C252.762 35.68 253.622 35.9 254.355 36.34C255.089 36.78 255.655 37.3733 256.055 38.12C256.455 38.8533 256.655 39.68 256.655 40.6C256.655 40.7333 256.655 40.88 256.655 41.04C256.655 41.2 256.642 41.3667 256.615 41.54H248.415V40H254.235C254.209 39.2667 253.962 38.6933 253.495 38.28C253.029 37.8533 252.449 37.64 251.755 37.64C251.262 37.64 250.809 37.7533 250.395 37.98C249.982 38.2067 249.655 38.5467 249.415 39C249.175 39.44 249.055 40 249.055 40.68V41.26C249.055 41.8867 249.169 42.4267 249.395 42.88C249.635 43.3333 249.955 43.68 250.355 43.92C250.769 44.1467 251.229 44.26 251.735 44.26C252.295 44.26 252.755 44.14 253.115 43.9C253.489 43.66 253.762 43.34 253.935 42.94H256.375C256.189 43.5667 255.882 44.1333 255.455 44.64C255.029 45.1333 254.502 45.5267 253.875 45.82C253.249 46.1 252.542 46.24 251.755 46.24ZM263.651 46.24C262.665 46.24 261.778 46.02 260.991 45.58C260.218 45.1267 259.611 44.5067 259.171 43.72C258.745 42.92 258.531 42.0133 258.531 41C258.531 39.9467 258.745 39.0267 259.171 38.24C259.611 37.44 260.218 36.8133 260.991 36.36C261.778 35.9067 262.671 35.68 263.671 35.68C264.925 35.68 265.978 36.0133 266.831 36.68C267.685 37.3333 268.231 38.2333 268.471 39.38H265.951C265.818 38.8733 265.538 38.4733 265.111 38.18C264.698 37.8867 264.205 37.74 263.631 37.74C263.138 37.74 262.685 37.8667 262.271 38.12C261.871 38.3733 261.551 38.74 261.311 39.22C261.085 39.7 260.971 40.28 260.971 40.96C260.971 41.48 261.038 41.94 261.171 42.34C261.305 42.74 261.491 43.08 261.731 43.36C261.985 43.6267 262.271 43.8333 262.591 43.98C262.911 44.1267 263.258 44.2 263.631 44.2C264.018 44.2 264.365 44.14 264.671 44.02C264.991 43.8867 265.258 43.6933 265.471 43.44C265.698 43.1867 265.858 42.8867 265.951 42.54H268.471C268.231 43.66 267.685 44.56 266.831 45.24C265.978 45.9067 264.918 46.24 263.651 46.24ZM275.009 46C274.329 46 273.736 45.8933 273.229 45.68C272.736 45.4667 272.349 45.1133 272.069 44.62C271.789 44.1267 271.649 43.46 271.649 42.62V37.94H269.929V35.92H271.649L271.929 33.26H274.049V35.92H276.789V37.94H274.049V42.62C274.049 43.1267 274.156 43.48 274.369 43.68C274.596 43.8667 274.969 43.96 275.489 43.96H276.729V46H275.009ZM283.493 46.24C282.533 46.24 281.666 46.02 280.893 45.58C280.133 45.1267 279.533 44.5067 279.093 43.72C278.666 42.92 278.453 42.0067 278.453 40.98C278.453 39.9267 278.673 39.0067 279.113 38.22C279.553 37.42 280.153 36.8 280.913 36.36C281.686 35.9067 282.553 35.68 283.513 35.68C284.473 35.68 285.333 35.9067 286.093 36.36C286.866 36.8 287.466 37.4133 287.893 38.2C288.333 38.9867 288.553 39.9067 288.553 40.96C288.553 42.0133 288.333 42.9333 287.893 43.72C287.453 44.5067 286.846 45.1267 286.073 45.58C285.313 46.02 284.453 46.24 283.493 46.24ZM283.493 44.18C283.973 44.18 284.406 44.06 284.793 43.82C285.193 43.58 285.513 43.22 285.753 42.74C285.993 42.26 286.113 41.6667 286.113 40.96C286.113 40.2533 285.993 39.6667 285.753 39.2C285.526 38.72 285.213 38.36 284.813 38.12C284.426 37.88 283.993 37.76 283.513 37.76C283.046 37.76 282.613 37.88 282.213 38.12C281.813 38.36 281.493 38.72 281.253 39.2C281.013 39.6667 280.893 40.2533 280.893 40.96C280.893 41.6667 281.013 42.26 281.253 42.74C281.493 43.22 281.806 43.58 282.193 43.82C282.593 44.06 283.026 44.18 283.493 44.18ZM290.903 46V35.92H293.043L293.263 37.8C293.503 37.36 293.803 36.9867 294.163 36.68C294.523 36.36 294.943 36.1133 295.423 35.94C295.916 35.7667 296.456 35.68 297.043 35.68V38.22H296.203C295.803 38.22 295.423 38.2733 295.063 38.38C294.703 38.4733 294.389 38.6333 294.123 38.86C293.869 39.0733 293.669 39.3733 293.523 39.76C293.376 40.1333 293.303 40.6067 293.303 41.18V46H290.903ZM302.872 46.24C301.978 46.24 301.198 46.1 300.532 45.82C299.878 45.5267 299.358 45.1267 298.972 44.62C298.598 44.1 298.378 43.5067 298.312 42.84H300.712C300.778 43.12 300.898 43.38 301.072 43.62C301.245 43.8467 301.478 44.0267 301.772 44.16C302.078 44.2933 302.438 44.36 302.852 44.36C303.252 44.36 303.578 44.3067 303.832 44.2C304.085 44.08 304.272 43.9267 304.392 43.74C304.512 43.5533 304.572 43.3533 304.572 43.14C304.572 42.82 304.485 42.5733 304.312 42.4C304.138 42.2267 303.885 42.0933 303.552 42C303.232 41.8933 302.845 41.7933 302.392 41.7C301.912 41.6067 301.445 41.4933 300.992 41.36C300.552 41.2133 300.152 41.0333 299.792 40.82C299.445 40.6067 299.165 40.3333 298.952 40C298.752 39.6667 298.652 39.26 298.652 38.78C298.652 38.1933 298.805 37.6667 299.112 37.2C299.432 36.7333 299.885 36.3667 300.472 36.1C301.072 35.82 301.785 35.68 302.612 35.68C303.785 35.68 304.718 35.9533 305.412 36.5C306.118 37.0333 306.532 37.7867 306.652 38.76H304.372C304.305 38.3867 304.118 38.1 303.812 37.9C303.505 37.6867 303.098 37.58 302.592 37.58C302.072 37.58 301.672 37.68 301.392 37.88C301.125 38.0667 300.992 38.32 300.992 38.64C300.992 38.84 301.072 39.0267 301.232 39.2C301.405 39.36 301.652 39.5 301.972 39.62C302.292 39.7267 302.685 39.8333 303.152 39.94C303.898 40.0867 304.558 40.26 305.132 40.46C305.705 40.66 306.158 40.9533 306.492 41.34C306.825 41.7267 306.992 42.2733 306.992 42.98C307.005 43.62 306.838 44.1867 306.492 44.68C306.158 45.1733 305.685 45.56 305.072 45.84C304.458 46.1067 303.725 46.24 302.872 46.24Z"
      fill="white"
    />
    <path
      d="M569.42 20V6H572.26L576.74 15.04L581.18 6H584.04V20H581.64V10.12L577.68 18.04H575.8L571.82 10.14V20H569.42ZM591.501 20.24C590.541 20.24 589.674 20.02 588.901 19.58C588.141 19.1267 587.541 18.5067 587.101 17.72C586.674 16.92 586.461 16.0067 586.461 14.98C586.461 13.9267 586.681 13.0067 587.121 12.22C587.561 11.42 588.161 10.8 588.921 10.36C589.694 9.90667 590.561 9.68 591.521 9.68C592.481 9.68 593.341 9.90667 594.101 10.36C594.874 10.8 595.474 11.4133 595.901 12.2C596.341 12.9867 596.561 13.9067 596.561 14.96C596.561 16.0133 596.341 16.9333 595.901 17.72C595.461 18.5067 594.854 19.1267 594.081 19.58C593.321 20.02 592.461 20.24 591.501 20.24ZM591.501 18.18C591.981 18.18 592.414 18.06 592.801 17.82C593.201 17.58 593.521 17.22 593.761 16.74C594.001 16.26 594.121 15.6667 594.121 14.96C594.121 14.2533 594.001 13.6667 593.761 13.2C593.534 12.72 593.221 12.36 592.821 12.12C592.434 11.88 592.001 11.76 591.521 11.76C591.054 11.76 590.621 11.88 590.221 12.12C589.821 12.36 589.501 12.72 589.261 13.2C589.021 13.6667 588.901 14.2533 588.901 14.96C588.901 15.6667 589.021 16.26 589.261 16.74C589.501 17.22 589.814 17.58 590.201 17.82C590.601 18.06 591.034 18.18 591.501 18.18ZM603.39 20.24C602.457 20.24 601.624 20.0133 600.89 19.56C600.157 19.1067 599.584 18.48 599.17 17.68C598.77 16.88 598.57 15.9733 598.57 14.96C598.57 13.9467 598.777 13.0467 599.19 12.26C599.604 11.46 600.177 10.8333 600.91 10.38C601.657 9.91333 602.497 9.68 603.43 9.68C604.19 9.68 604.85 9.82667 605.41 10.12C605.984 10.4 606.437 10.8 606.77 11.32V5.6H609.17V20H607.01L606.77 18.54C606.557 18.8333 606.297 19.1133 605.99 19.38C605.684 19.6333 605.317 19.84 604.89 20C604.464 20.16 603.964 20.24 603.39 20.24ZM603.89 18.16C604.464 18.16 604.97 18.0267 605.41 17.76C605.85 17.48 606.19 17.1 606.43 16.62C606.67 16.14 606.79 15.5867 606.79 14.96C606.79 14.3333 606.67 13.78 606.43 13.3C606.19 12.82 605.85 12.4467 605.41 12.18C604.97 11.9133 604.464 11.78 603.89 11.78C603.344 11.78 602.85 11.9133 602.41 12.18C601.97 12.4467 601.624 12.82 601.37 13.3C601.13 13.78 601.01 14.3333 601.01 14.96C601.01 15.5867 601.13 16.14 601.37 16.62C601.624 17.1 601.97 17.48 602.41 17.76C602.85 18.0267 603.344 18.16 603.89 18.16ZM616.56 20.24C615.56 20.24 614.68 20.0267 613.92 19.6C613.16 19.16 612.567 18.5467 612.14 17.76C611.713 16.9733 611.5 16.0667 611.5 15.04C611.5 13.9733 611.707 13.04 612.12 12.24C612.547 11.44 613.14 10.8133 613.9 10.36C614.673 9.90667 615.567 9.68 616.58 9.68C617.567 9.68 618.427 9.9 619.16 10.34C619.893 10.78 620.46 11.3733 620.86 12.12C621.26 12.8533 621.46 13.68 621.46 14.6C621.46 14.7333 621.46 14.88 621.46 15.04C621.46 15.2 621.447 15.3667 621.42 15.54H613.22V14H619.04C619.013 13.2667 618.767 12.6933 618.3 12.28C617.833 11.8533 617.253 11.64 616.56 11.64C616.067 11.64 615.613 11.7533 615.2 11.98C614.787 12.2067 614.46 12.5467 614.22 13C613.98 13.44 613.86 14 613.86 14.68V15.26C613.86 15.8867 613.973 16.4267 614.2 16.88C614.44 17.3333 614.76 17.68 615.16 17.92C615.573 18.1467 616.033 18.26 616.54 18.26C617.1 18.26 617.56 18.14 617.92 17.9C618.293 17.66 618.567 17.34 618.74 16.94H621.18C620.993 17.5667 620.687 18.1333 620.26 18.64C619.833 19.1333 619.307 19.5267 618.68 19.82C618.053 20.1 617.347 20.24 616.56 20.24ZM623.676 20V5.6H626.076V20H623.676Z"
      fill="white"
    />
    <path
      d="M891.699 20V6H896.719C897.826 6 898.739 6.19333 899.459 6.58C900.193 6.95333 900.733 7.46 901.079 8.1C901.439 8.72667 901.619 9.44 901.619 10.24C901.619 10.9867 901.446 11.68 901.099 12.32C900.753 12.96 900.213 13.4733 899.479 13.86C898.746 14.2467 897.806 14.44 896.659 14.44H894.099V20H891.699ZM898.999 20L896.059 13.82H898.659L901.739 20H898.999ZM894.099 12.66H896.559C897.453 12.66 898.106 12.4467 898.519 12.02C898.946 11.58 899.159 11.0067 899.159 10.3C899.159 9.60667 898.953 9.05333 898.539 8.64C898.126 8.21333 897.466 8 896.559 8H894.099V12.66ZM908.136 20.24C907.136 20.24 906.256 20.0267 905.496 19.6C904.736 19.16 904.143 18.5467 903.716 17.76C903.29 16.9733 903.076 16.0667 903.076 15.04C903.076 13.9733 903.283 13.04 903.696 12.24C904.123 11.44 904.716 10.8133 905.476 10.36C906.25 9.90667 907.143 9.68 908.156 9.68C909.143 9.68 910.003 9.9 910.736 10.34C911.47 10.78 912.036 11.3733 912.436 12.12C912.836 12.8533 913.036 13.68 913.036 14.6C913.036 14.7333 913.036 14.88 913.036 15.04C913.036 15.2 913.023 15.3667 912.996 15.54H904.796V14H910.616C910.59 13.2667 910.343 12.6933 909.876 12.28C909.41 11.8533 908.83 11.64 908.136 11.64C907.643 11.64 907.19 11.7533 906.776 11.98C906.363 12.2067 906.036 12.5467 905.796 13C905.556 13.44 905.436 14 905.436 14.68V15.26C905.436 15.8867 905.55 16.4267 905.776 16.88C906.016 17.3333 906.336 17.68 906.736 17.92C907.15 18.1467 907.61 18.26 908.116 18.26C908.676 18.26 909.136 18.14 909.496 17.9C909.87 17.66 910.143 17.34 910.316 16.94H912.756C912.57 17.5667 912.263 18.1333 911.836 18.64C911.41 19.1333 910.883 19.5267 910.256 19.82C909.63 20.1 908.923 20.24 908.136 20.24ZM918.612 20.24C917.785 20.24 917.099 20.1 916.552 19.82C916.005 19.54 915.599 19.1667 915.332 18.7C915.065 18.2333 914.932 17.7267 914.932 17.18C914.932 16.54 915.092 15.9867 915.412 15.52C915.745 15.0533 916.232 14.6933 916.872 14.44C917.512 14.1733 918.299 14.04 919.232 14.04H921.772C921.772 13.5067 921.699 13.0667 921.552 12.72C921.405 12.36 921.179 12.0933 920.872 11.92C920.565 11.7467 920.172 11.66 919.692 11.66C919.145 11.66 918.679 11.7867 918.292 12.04C917.905 12.28 917.665 12.6533 917.572 13.16H915.212C915.292 12.44 915.532 11.8267 915.932 11.32C916.332 10.8 916.859 10.4 917.512 10.12C918.179 9.82667 918.905 9.68 919.692 9.68C920.639 9.68 921.445 9.84667 922.112 10.18C922.779 10.5 923.285 10.9667 923.632 11.58C923.992 12.18 924.172 12.9067 924.172 13.76V20H922.132L921.892 18.38C921.759 18.6467 921.585 18.8933 921.372 19.12C921.172 19.3467 920.939 19.5467 920.672 19.72C920.405 19.88 920.099 20.0067 919.752 20.1C919.419 20.1933 919.039 20.24 918.612 20.24ZM919.152 18.34C919.539 18.34 919.879 18.2733 920.172 18.14C920.479 17.9933 920.739 17.7933 920.952 17.54C921.179 17.2733 921.352 16.98 921.472 16.66C921.592 16.34 921.672 16 921.712 15.64V15.6H919.492C919.025 15.6 918.639 15.66 918.332 15.78C918.025 15.8867 917.805 16.0467 917.672 16.26C917.539 16.4733 917.472 16.72 917.472 17C917.472 17.28 917.539 17.52 917.672 17.72C917.805 17.92 917.999 18.0733 918.252 18.18C918.505 18.2867 918.805 18.34 919.152 18.34ZM926.736 20V5.6H929.136V20H926.736ZM940.037 20V7.94H935.917V6H946.537V7.94H942.417V20H940.037ZM948.536 20V9.92H950.936V20H948.536ZM949.736 8.32C949.296 8.32 948.929 8.18667 948.636 7.92C948.356 7.64 948.216 7.3 948.216 6.9C948.216 6.48667 948.356 6.15333 948.636 5.9C948.929 5.63333 949.296 5.5 949.736 5.5C950.176 5.5 950.536 5.63333 950.816 5.9C951.109 6.15333 951.256 6.48667 951.256 6.9C951.256 7.3 951.109 7.64 950.816 7.92C950.536 8.18667 950.176 8.32 949.736 8.32ZM953.709 20V9.92H955.829L956.029 11.3C956.349 10.7933 956.769 10.4 957.289 10.12C957.822 9.82667 958.429 9.68 959.109 9.68C959.616 9.68 960.069 9.74667 960.469 9.88C960.882 10.0133 961.242 10.2133 961.549 10.48C961.869 10.7467 962.129 11.08 962.329 11.48C962.702 10.92 963.189 10.48 963.789 10.16C964.389 9.84 965.042 9.68 965.749 9.68C966.589 9.68 967.302 9.85333 967.889 10.2C968.476 10.5333 968.922 11.0333 969.229 11.7C969.536 12.3533 969.689 13.16 969.689 14.12V20H967.309V14.36C967.309 13.5067 967.136 12.8533 966.789 12.4C966.442 11.9467 965.929 11.72 965.249 11.72C964.782 11.72 964.369 11.8333 964.009 12.06C963.662 12.2867 963.389 12.62 963.189 13.06C962.989 13.4867 962.889 14.0133 962.889 14.64V20H960.509V14.36C960.509 13.5067 960.336 12.8533 959.989 12.4C959.642 11.9467 959.122 11.72 958.429 11.72C957.989 11.72 957.589 11.8333 957.229 12.06C956.882 12.2867 956.609 12.62 956.409 13.06C956.209 13.4867 956.109 14.0133 956.109 14.64V20H953.709ZM976.945 20.24C975.945 20.24 975.065 20.0267 974.305 19.6C973.545 19.16 972.951 18.5467 972.525 17.76C972.098 16.9733 971.885 16.0667 971.885 15.04C971.885 13.9733 972.091 13.04 972.505 12.24C972.931 11.44 973.525 10.8133 974.285 10.36C975.058 9.90667 975.951 9.68 976.965 9.68C977.951 9.68 978.811 9.9 979.545 10.34C980.278 10.78 980.845 11.3733 981.245 12.12C981.645 12.8533 981.845 13.68 981.845 14.6C981.845 14.7333 981.845 14.88 981.845 15.04C981.845 15.2 981.831 15.3667 981.805 15.54H973.605V14H979.425C979.398 13.2667 979.151 12.6933 978.685 12.28C978.218 11.8533 977.638 11.64 976.945 11.64C976.451 11.64 975.998 11.7533 975.585 11.98C975.171 12.2067 974.845 12.5467 974.605 13C974.365 13.44 974.245 14 974.245 14.68V15.26C974.245 15.8867 974.358 16.4267 974.585 16.88C974.825 17.3333 975.145 17.68 975.545 17.92C975.958 18.1467 976.418 18.26 976.925 18.26C977.485 18.26 977.945 18.14 978.305 17.9C978.678 17.66 978.951 17.34 979.125 16.94H981.565C981.378 17.5667 981.071 18.1333 980.645 18.64C980.218 19.1333 979.691 19.5267 979.065 19.82C978.438 20.1 977.731 20.24 976.945 20.24ZM878.446 46V33.94H874.326V32H884.946V33.94H880.826V46H878.446ZM889.767 46.24C888.767 46.24 887.887 46.0267 887.127 45.6C886.367 45.16 885.774 44.5467 885.347 43.76C884.92 42.9733 884.707 42.0667 884.707 41.04C884.707 39.9733 884.914 39.04 885.327 38.24C885.754 37.44 886.347 36.8133 887.107 36.36C887.88 35.9067 888.774 35.68 889.787 35.68C890.774 35.68 891.634 35.9 892.367 36.34C893.1 36.78 893.667 37.3733 894.067 38.12C894.467 38.8533 894.667 39.68 894.667 40.6C894.667 40.7333 894.667 40.88 894.667 41.04C894.667 41.2 894.654 41.3667 894.627 41.54H886.427V40H892.247C892.22 39.2667 891.974 38.6933 891.507 38.28C891.04 37.8533 890.46 37.64 889.767 37.64C889.274 37.64 888.82 37.7533 888.407 37.98C887.994 38.2067 887.667 38.5467 887.427 39C887.187 39.44 887.067 40 887.067 40.68V41.26C887.067 41.8867 887.18 42.4267 887.407 42.88C887.647 43.3333 887.967 43.68 888.367 43.92C888.78 44.1467 889.24 44.26 889.747 44.26C890.307 44.26 890.767 44.14 891.127 43.9C891.5 43.66 891.774 43.34 891.947 42.94H894.387C894.2 43.5667 893.894 44.1333 893.467 44.64C893.04 45.1333 892.514 45.5267 891.887 45.82C891.26 46.1 890.554 46.24 889.767 46.24ZM895.298 46L898.858 40.96L895.298 35.92H897.878L900.398 39.58L902.918 35.92H905.498L901.938 40.96L905.498 46H902.918L900.398 42.34L897.878 46H895.298ZM911.595 46C910.915 46 910.322 45.8933 909.815 45.68C909.322 45.4667 908.935 45.1133 908.655 44.62C908.375 44.1267 908.235 43.46 908.235 42.62V37.94H906.515V35.92H908.235L908.515 33.26H910.635V35.92H913.375V37.94H910.635V42.62C910.635 43.1267 910.742 43.48 910.955 43.68C911.182 43.8667 911.555 43.96 912.075 43.96H913.315V46H911.595ZM919.676 46L924.796 32H927.476L932.596 46H930.056L926.116 34.8L922.176 46H919.676ZM921.956 42.7L922.596 40.8H929.496L930.136 42.7H921.956ZM934.442 46V35.92H936.562L936.742 37.6C937.048 37.0133 937.488 36.5467 938.062 36.2C938.635 35.8533 939.315 35.68 940.102 35.68C940.915 35.68 941.608 35.8533 942.182 36.2C942.755 36.5333 943.195 37.0267 943.502 37.68C943.822 38.3333 943.982 39.1467 943.982 40.12V46H941.582V40.34C941.582 39.5 941.395 38.8533 941.022 38.4C940.648 37.9467 940.095 37.72 939.362 37.72C938.882 37.72 938.448 37.8333 938.062 38.06C937.688 38.2867 937.388 38.62 937.162 39.06C936.948 39.4867 936.842 40.0067 936.842 40.62V46H934.442ZM949.872 46.24C949.045 46.24 948.359 46.1 947.812 45.82C947.265 45.54 946.859 45.1667 946.592 44.7C946.325 44.2333 946.192 43.7267 946.192 43.18C946.192 42.54 946.352 41.9867 946.672 41.52C947.005 41.0533 947.492 40.6933 948.132 40.44C948.772 40.1733 949.559 40.04 950.492 40.04H953.032C953.032 39.5067 952.959 39.0667 952.812 38.72C952.665 38.36 952.439 38.0933 952.132 37.92C951.825 37.7467 951.432 37.66 950.952 37.66C950.405 37.66 949.939 37.7867 949.552 38.04C949.165 38.28 948.925 38.6533 948.832 39.16H946.472C946.552 38.44 946.792 37.8267 947.192 37.32C947.592 36.8 948.119 36.4 948.772 36.12C949.439 35.8267 950.165 35.68 950.952 35.68C951.899 35.68 952.705 35.8467 953.372 36.18C954.039 36.5 954.545 36.9667 954.892 37.58C955.252 38.18 955.432 38.9067 955.432 39.76V46H953.392L953.152 44.38C953.019 44.6467 952.845 44.8933 952.632 45.12C952.432 45.3467 952.199 45.5467 951.932 45.72C951.665 45.88 951.359 46.0067 951.012 46.1C950.679 46.1933 950.299 46.24 949.872 46.24ZM950.412 44.34C950.799 44.34 951.139 44.2733 951.432 44.14C951.739 43.9933 951.999 43.7933 952.212 43.54C952.439 43.2733 952.612 42.98 952.732 42.66C952.852 42.34 952.932 42 952.972 41.64V41.6H950.752C950.285 41.6 949.899 41.66 949.592 41.78C949.285 41.8867 949.065 42.0467 948.932 42.26C948.799 42.4733 948.732 42.72 948.732 43C948.732 43.28 948.799 43.52 948.932 43.72C949.065 43.92 949.259 44.0733 949.512 44.18C949.765 44.2867 950.065 44.34 950.412 44.34ZM957.996 46V31.6H960.396V46H957.996ZM964.294 50.4L966.754 44.88H966.154L962.134 35.92H964.754L967.754 42.76L970.594 35.92H973.134L966.834 50.4H964.294ZM978.383 46.24C977.49 46.24 976.71 46.1 976.043 45.82C975.39 45.5267 974.87 45.1267 974.483 44.62C974.11 44.1 973.89 43.5067 973.823 42.84H976.223C976.29 43.12 976.41 43.38 976.583 43.62C976.757 43.8467 976.99 44.0267 977.283 44.16C977.59 44.2933 977.95 44.36 978.363 44.36C978.763 44.36 979.09 44.3067 979.343 44.2C979.597 44.08 979.783 43.9267 979.903 43.74C980.023 43.5533 980.083 43.3533 980.083 43.14C980.083 42.82 979.997 42.5733 979.823 42.4C979.65 42.2267 979.397 42.0933 979.063 42C978.743 41.8933 978.357 41.7933 977.903 41.7C977.423 41.6067 976.957 41.4933 976.503 41.36C976.063 41.2133 975.663 41.0333 975.303 40.82C974.957 40.6067 974.677 40.3333 974.463 40C974.263 39.6667 974.163 39.26 974.163 38.78C974.163 38.1933 974.317 37.6667 974.623 37.2C974.943 36.7333 975.397 36.3667 975.983 36.1C976.583 35.82 977.297 35.68 978.123 35.68C979.297 35.68 980.23 35.9533 980.923 36.5C981.63 37.0333 982.043 37.7867 982.163 38.76H979.883C979.817 38.3867 979.63 38.1 979.323 37.9C979.017 37.6867 978.61 37.58 978.103 37.58C977.583 37.58 977.183 37.68 976.903 37.88C976.637 38.0667 976.503 38.32 976.503 38.64C976.503 38.84 976.583 39.0267 976.743 39.2C976.917 39.36 977.163 39.5 977.483 39.62C977.803 39.7267 978.197 39.8333 978.663 39.94C979.41 40.0867 980.07 40.26 980.643 40.46C981.217 40.66 981.67 40.9533 982.003 41.34C982.337 41.7267 982.503 42.2733 982.503 42.98C982.517 43.62 982.35 44.1867 982.003 44.68C981.67 45.1733 981.197 45.56 980.583 45.84C979.97 46.1067 979.237 46.24 978.383 46.24ZM984.932 46V35.92H987.332V46H984.932ZM986.132 34.32C985.692 34.32 985.326 34.1867 985.032 33.92C984.752 33.64 984.612 33.3 984.612 32.9C984.612 32.4867 984.752 32.1533 985.032 31.9C985.326 31.6333 985.692 31.5 986.132 31.5C986.572 31.5 986.932 31.6333 987.212 31.9C987.506 32.1533 987.652 32.4867 987.652 32.9C987.652 33.3 987.506 33.64 987.212 33.92C986.932 34.1867 986.572 34.32 986.132 34.32ZM994.126 46.24C993.232 46.24 992.452 46.1 991.786 45.82C991.132 45.5267 990.612 45.1267 990.226 44.62C989.852 44.1 989.632 43.5067 989.566 42.84H991.966C992.032 43.12 992.152 43.38 992.326 43.62C992.499 43.8467 992.732 44.0267 993.026 44.16C993.332 44.2933 993.692 44.36 994.106 44.36C994.506 44.36 994.832 44.3067 995.086 44.2C995.339 44.08 995.526 43.9267 995.646 43.74C995.766 43.5533 995.826 43.3533 995.826 43.14C995.826 42.82 995.739 42.5733 995.566 42.4C995.392 42.2267 995.139 42.0933 994.806 42C994.486 41.8933 994.099 41.7933 993.646 41.7C993.166 41.6067 992.699 41.4933 992.246 41.36C991.806 41.2133 991.406 41.0333 991.046 40.82C990.699 40.6067 990.419 40.3333 990.206 40C990.006 39.6667 989.906 39.26 989.906 38.78C989.906 38.1933 990.059 37.6667 990.366 37.2C990.686 36.7333 991.139 36.3667 991.726 36.1C992.326 35.82 993.039 35.68 993.866 35.68C995.039 35.68 995.972 35.9533 996.666 36.5C997.372 37.0333 997.786 37.7867 997.906 38.76H995.626C995.559 38.3867 995.372 38.1 995.066 37.9C994.759 37.6867 994.352 37.58 993.846 37.58C993.326 37.58 992.926 37.68 992.646 37.88C992.379 38.0667 992.246 38.32 992.246 38.64C992.246 38.84 992.326 39.0267 992.486 39.2C992.659 39.36 992.906 39.5 993.226 39.62C993.546 39.7267 993.939 39.8333 994.406 39.94C995.152 40.0867 995.812 40.26 996.386 40.46C996.959 40.66 997.412 40.9533 997.746 41.34C998.079 41.7267 998.246 42.2733 998.246 42.98C998.259 43.62 998.092 44.1867 997.746 44.68C997.412 45.1733 996.939 45.56 996.326 45.84C995.712 46.1067 994.979 46.24 994.126 46.24Z"
      fill="white"
    />
    <path
      d="M189.709 151.453C190.1 151.063 190.1 150.43 189.709 150.039L183.345 143.675C182.955 143.285 182.321 143.285 181.931 143.675C181.54 144.066 181.54 144.699 181.931 145.089L187.588 150.746L181.931 156.403C181.54 156.793 181.54 157.427 181.931 157.817C182.321 158.208 182.955 158.208 183.345 157.817L189.709 151.453ZM125.963 151.746H189.002V149.746H125.963V151.746Z"
      fill="white"
    />
    <path
      d="M429.709 151.453C430.1 151.063 430.1 150.43 429.709 150.039L423.345 143.675C422.955 143.285 422.321 143.285 421.931 143.675C421.54 144.066 421.54 144.699 421.931 145.089L427.588 150.746L421.931 156.403C421.54 156.793 421.54 157.427 421.931 157.817C422.321 158.208 422.955 158.208 423.345 157.817L429.709 151.453ZM365.963 151.746H429.002V149.746H365.963V151.746Z"
      fill="white"
    />
    <path
      d="M871.709 151.453C872.1 151.063 872.1 150.43 871.709 150.039L865.345 143.675C864.955 143.285 864.321 143.285 863.931 143.675C863.54 144.066 863.54 144.699 863.931 145.089L869.588 150.746L863.931 156.403C863.54 156.793 863.54 157.427 863.931 157.817C864.321 158.208 864.955 158.208 865.345 157.817L871.709 151.453ZM807.963 151.746H871.002V149.746H807.963V151.746Z"
      fill="white"
    />
    <path
      d="M233.426 90.5478C231.6 91.2522 229.643 93.1565 228.73 95.087L228 96.6522V150V203.348L228.73 204.913C229.67 206.896 231.6 208.748 233.504 209.478C234.913 210 235.278 210 273 210C310.722 210 311.087 210 312.496 209.478C314.4 208.748 316.33 206.896 317.27 204.913L318 203.348L318.078 158.739L318.13 114.157L306.078 102.078L294 90L264.391 90.0261C235.461 90.0261 234.757 90.0261 233.426 90.5478ZM291.835 102.052C291.913 110.922 291.939 111.287 292.487 112.304C293.217 113.687 294.522 114.887 295.957 115.539C297.052 116.035 297.652 116.087 306.078 116.087H315V148.565V184.174H273H231V139.252V97.4609L231.548 96.3391C232.174 95.0609 233.661 93.7044 234.939 93.2348C235.617 92.9739 242.53 92.8957 263.791 92.8957L291.757 92.8696L291.835 102.052ZM305.948 113.165C302.087 113.191 298.565 113.165 298.096 113.087C296.817 112.852 295.304 111.365 294.939 109.957C294.757 109.252 294.652 106.096 294.652 101.817V94.8261L303.783 103.957L312.913 113.087L305.948 113.165ZM315 193.304C315 200.4 314.922 202.643 314.661 203.296C314.087 204.652 312.887 205.852 311.478 206.504L310.174 207.13H273H235.826L234.522 206.504C233.113 205.852 231.913 204.652 231.339 203.296C231.078 202.643 231 200.4 231 193.304V184.174H273H315V193.304Z"
      fill="white"
    />
    <path
      d="M233.426 90.5478C231.6 91.2522 229.643 93.1565 228.73 95.087L228 96.6522V150V203.348L228.73 204.913C229.67 206.896 231.6 208.748 233.504 209.478C234.913 210 235.278 210 273 210C310.722 210 311.087 210 312.496 209.478C314.4 208.748 316.33 206.896 317.27 204.913L318 203.348L318.078 158.739L318.13 114.157L306.078 102.078L294 90L264.391 90.0261C235.461 90.0261 234.757 90.0261 233.426 90.5478ZM291.835 102.052C291.913 110.922 291.939 111.287 292.487 112.304C293.217 113.687 294.522 114.887 295.957 115.539C297.052 116.035 297.652 116.087 306.078 116.087H315V148.565V184.174H273H231V139.252V97.4609L231.548 96.3391C232.174 95.0609 233.661 93.7044 234.939 93.2348C235.617 92.9739 242.53 92.8957 263.791 92.8957L291.757 92.8696L291.835 102.052ZM305.948 113.165C302.087 113.191 298.565 113.165 298.096 113.087C296.817 112.852 295.304 111.365 294.939 109.957C294.757 109.252 294.652 106.096 294.652 101.817V94.8261L303.783 103.957L312.913 113.087L305.948 113.165ZM315 193.304C315 200.4 314.922 202.643 314.661 203.296C314.087 204.652 312.887 205.852 311.478 206.504L310.174 207.13H273H235.826L234.522 206.504C233.113 205.852 231.913 204.652 231.339 203.296C231.078 202.643 231 200.4 231 193.304V184.174H273H315V193.304Z"
      fill="white"
    />
    <path
      d="M239.125 113V101.74L236.645 102.38V100.52L240.085 99H241.585V113H239.125ZM245.359 113.1C244.905 113.1 244.539 112.96 244.259 112.68C243.979 112.4 243.839 112.067 243.839 111.68C243.839 111.267 243.979 110.92 244.259 110.64C244.539 110.36 244.905 110.22 245.359 110.22C245.799 110.22 246.159 110.36 246.439 110.64C246.719 110.92 246.859 111.267 246.859 111.68C246.859 112.067 246.719 112.4 246.439 112.68C246.159 112.96 245.799 113.1 245.359 113.1ZM248.785 113V111.26C249.678 110.553 250.532 109.847 251.345 109.14C252.158 108.433 252.892 107.733 253.545 107.04C254.198 106.347 254.712 105.667 255.085 105C255.458 104.333 255.645 103.693 255.645 103.08C255.645 102.68 255.572 102.307 255.425 101.96C255.278 101.613 255.045 101.333 254.725 101.12C254.418 100.907 254.005 100.8 253.485 100.8C252.978 100.8 252.545 100.913 252.185 101.14C251.838 101.367 251.578 101.673 251.405 102.06C251.232 102.433 251.145 102.86 251.145 103.34H248.825C248.852 102.327 249.072 101.48 249.485 100.8C249.898 100.12 250.458 99.6133 251.165 99.28C251.872 98.9333 252.665 98.76 253.545 98.76C254.492 98.76 255.298 98.9333 255.965 99.28C256.632 99.6267 257.145 100.113 257.505 100.74C257.865 101.367 258.045 102.107 258.045 102.96C258.045 103.587 257.925 104.207 257.685 104.82C257.458 105.42 257.138 106.007 256.725 106.58C256.312 107.14 255.845 107.687 255.325 108.22C254.818 108.74 254.292 109.24 253.745 109.72C253.198 110.187 252.672 110.62 252.165 111.02H258.425V113H248.785ZM265.208 113.24C264.301 113.24 263.475 113.08 262.728 112.76C261.981 112.427 261.381 111.927 260.928 111.26C260.488 110.58 260.255 109.727 260.228 108.7H262.588C262.601 109.167 262.708 109.593 262.908 109.98C263.121 110.353 263.421 110.653 263.808 110.88C264.195 111.093 264.661 111.2 265.208 111.2C265.728 111.2 266.168 111.1 266.528 110.9C266.901 110.7 267.181 110.427 267.368 110.08C267.555 109.733 267.648 109.347 267.648 108.92C267.648 108.4 267.521 107.973 267.268 107.64C267.015 107.293 266.668 107.033 266.228 106.86C265.788 106.687 265.288 106.6 264.728 106.6H263.688V104.62H264.728C265.461 104.62 266.061 104.453 266.528 104.12C266.995 103.773 267.228 103.273 267.228 102.62C267.228 102.073 267.048 101.633 266.688 101.3C266.341 100.967 265.841 100.8 265.188 100.8C264.508 100.8 263.968 101 263.568 101.4C263.181 101.8 262.968 102.293 262.928 102.88H260.568C260.608 102.04 260.821 101.313 261.208 100.7C261.608 100.073 262.148 99.5933 262.828 99.26C263.508 98.9267 264.301 98.76 265.208 98.76C266.155 98.76 266.955 98.9267 267.608 99.26C268.261 99.5933 268.755 100.04 269.088 100.6C269.435 101.16 269.608 101.773 269.608 102.44C269.608 102.96 269.508 103.433 269.308 103.86C269.108 104.287 268.835 104.647 268.488 104.94C268.155 105.22 267.761 105.427 267.308 105.56C267.828 105.667 268.288 105.873 268.688 106.18C269.101 106.487 269.421 106.88 269.648 107.36C269.888 107.827 270.008 108.373 270.008 109C270.008 109.76 269.821 110.467 269.448 111.12C269.088 111.76 268.548 112.273 267.828 112.66C267.121 113.047 266.248 113.24 265.208 113.24ZM279.021 113V110.34H272.081V108.42L278.681 99H281.401V108.24H283.301V110.34H281.401V113H279.021ZM274.661 108.24H279.161V101.64L274.661 108.24Z"
      fill="#FF6600"
    />
    <path
      d="M241.834 134.24C240.834 134.24 239.967 134.067 239.234 133.72C238.514 133.36 237.947 132.873 237.534 132.26C237.121 131.633 236.874 130.927 236.794 130.14H239.134C239.254 130.727 239.554 131.22 240.034 131.62C240.514 132.007 241.114 132.2 241.834 132.2C242.381 132.2 242.847 132.073 243.234 131.82C243.621 131.553 243.921 131.2 244.134 130.76C244.361 130.307 244.474 129.8 244.474 129.24C244.474 128.667 244.361 128.167 244.134 127.74C243.921 127.313 243.621 126.987 243.234 126.76C242.847 126.52 242.401 126.4 241.894 126.4C241.267 126.4 240.727 126.547 240.274 126.84C239.834 127.12 239.514 127.473 239.314 127.9H236.994L238.154 120H245.874V122.1H239.954L239.314 125.56C239.621 125.227 240.027 124.96 240.534 124.76C241.041 124.547 241.621 124.44 242.274 124.44C243.007 124.44 243.654 124.567 244.214 124.82C244.774 125.073 245.247 125.42 245.634 125.86C246.021 126.3 246.307 126.813 246.494 127.4C246.694 127.973 246.794 128.58 246.794 129.22C246.794 129.94 246.674 130.607 246.434 131.22C246.194 131.82 245.854 132.347 245.414 132.8C244.987 133.253 244.467 133.607 243.854 133.86C243.254 134.113 242.581 134.24 241.834 134.24ZM254.457 134.24C253.417 134.24 252.537 134.047 251.817 133.66C251.111 133.273 250.544 132.76 250.117 132.12C249.691 131.467 249.377 130.74 249.177 129.94C248.977 129.14 248.877 128.32 248.877 127.48C248.877 125.92 249.097 124.567 249.537 123.42C249.977 122.26 250.604 121.36 251.417 120.72C252.244 120.08 253.237 119.76 254.397 119.76C255.357 119.76 256.164 119.947 256.817 120.32C257.484 120.68 258.004 121.16 258.377 121.76C258.751 122.36 258.977 123.013 259.057 123.72H256.817C256.697 123.093 256.424 122.613 255.997 122.28C255.584 121.933 255.044 121.76 254.377 121.76C253.777 121.76 253.244 121.947 252.777 122.32C252.311 122.693 251.944 123.253 251.677 124C251.411 124.747 251.257 125.693 251.217 126.84C251.217 126.867 251.217 126.893 251.217 126.92C251.217 126.933 251.217 126.953 251.217 126.98C251.431 126.593 251.717 126.253 252.077 125.96C252.437 125.653 252.851 125.413 253.317 125.24C253.797 125.067 254.311 124.98 254.857 124.98C255.644 124.98 256.371 125.167 257.037 125.54C257.717 125.9 258.264 126.42 258.677 127.1C259.104 127.78 259.317 128.58 259.317 129.5C259.317 130.34 259.117 131.12 258.717 131.84C258.317 132.56 257.751 133.14 257.017 133.58C256.284 134.02 255.431 134.24 254.457 134.24ZM254.317 132.18C254.837 132.18 255.297 132.067 255.697 131.84C256.097 131.613 256.411 131.307 256.637 130.92C256.877 130.533 256.997 130.093 256.997 129.6C256.997 129.08 256.877 128.627 256.637 128.24C256.411 127.853 256.091 127.553 255.677 127.34C255.277 127.127 254.817 127.02 254.297 127.02C253.791 127.02 253.331 127.133 252.917 127.36C252.517 127.573 252.197 127.873 251.957 128.26C251.717 128.647 251.597 129.087 251.597 129.58C251.597 130.087 251.717 130.533 251.957 130.92C252.197 131.307 252.517 131.613 252.917 131.84C253.331 132.067 253.797 132.18 254.317 132.18ZM268.314 134V131.34H261.374V129.42L267.974 120H270.694V129.24H272.594V131.34H270.694V134H268.314ZM263.954 129.24H268.454V122.64L263.954 129.24ZM275.648 134.1C275.194 134.1 274.828 133.96 274.548 133.68C274.268 133.4 274.128 133.067 274.128 132.68C274.128 132.267 274.268 131.92 274.548 131.64C274.828 131.36 275.194 131.22 275.648 131.22C276.088 131.22 276.448 131.36 276.728 131.64C277.008 131.92 277.148 132.267 277.148 132.68C277.148 133.067 277.008 133.4 276.728 133.68C276.448 133.96 276.088 134.1 275.648 134.1ZM284.334 134.24C283.334 134.24 282.467 134.067 281.734 133.72C281.014 133.36 280.447 132.873 280.034 132.26C279.621 131.633 279.374 130.927 279.294 130.14H281.634C281.754 130.727 282.054 131.22 282.534 131.62C283.014 132.007 283.614 132.2 284.334 132.2C284.881 132.2 285.347 132.073 285.734 131.82C286.121 131.553 286.421 131.2 286.634 130.76C286.861 130.307 286.974 129.8 286.974 129.24C286.974 128.667 286.861 128.167 286.634 127.74C286.421 127.313 286.121 126.987 285.734 126.76C285.347 126.52 284.901 126.4 284.394 126.4C283.767 126.4 283.227 126.547 282.774 126.84C282.334 127.12 282.014 127.473 281.814 127.9H279.494L280.654 120H288.374V122.1H282.454L281.814 125.56C282.121 125.227 282.527 124.96 283.034 124.76C283.541 124.547 284.121 124.44 284.774 124.44C285.507 124.44 286.154 124.567 286.714 124.82C287.274 125.073 287.747 125.42 288.134 125.86C288.521 126.3 288.807 126.813 288.994 127.4C289.194 127.973 289.294 128.58 289.294 129.22C289.294 129.94 289.174 130.607 288.934 131.22C288.694 131.82 288.354 132.347 287.914 132.8C287.487 133.253 286.967 133.607 286.354 133.86C285.754 134.113 285.081 134.24 284.334 134.24ZM295.95 134.24C295.003 134.24 294.196 134.06 293.53 133.7C292.876 133.327 292.363 132.84 291.99 132.24C291.616 131.627 291.396 130.973 291.33 130.28H293.55C293.67 130.907 293.936 131.393 294.35 131.74C294.776 132.073 295.323 132.24 295.99 132.24C296.603 132.24 297.136 132.06 297.59 131.7C298.043 131.327 298.403 130.773 298.67 130.04C298.95 129.293 299.103 128.36 299.13 127.24C299.13 127.213 299.13 127.18 299.13 127.14C299.13 127.1 299.13 127.06 299.13 127.02C298.93 127.393 298.65 127.733 298.29 128.04C297.93 128.347 297.51 128.587 297.03 128.76C296.563 128.933 296.056 129.02 295.51 129.02C294.736 129.02 294.003 128.84 293.31 128.48C292.63 128.107 292.083 127.58 291.67 126.9C291.256 126.22 291.05 125.42 291.05 124.5C291.05 123.66 291.25 122.88 291.65 122.16C292.05 121.44 292.616 120.86 293.35 120.42C294.083 119.98 294.93 119.76 295.89 119.76C296.943 119.76 297.823 119.953 298.53 120.34C299.25 120.727 299.823 121.247 300.25 121.9C300.676 122.54 300.983 123.26 301.17 124.06C301.37 124.86 301.47 125.68 301.47 126.52C301.47 128.067 301.25 129.42 300.81 130.58C300.383 131.74 299.756 132.64 298.93 133.28C298.116 133.92 297.123 134.24 295.95 134.24ZM296.07 126.98C296.576 126.98 297.03 126.873 297.43 126.66C297.843 126.433 298.17 126.127 298.41 125.74C298.65 125.34 298.77 124.9 298.77 124.42C298.77 123.913 298.65 123.467 298.41 123.08C298.17 122.68 297.843 122.373 297.43 122.16C297.03 121.933 296.57 121.82 296.05 121.82C295.53 121.82 295.07 121.933 294.67 122.16C294.27 122.387 293.95 122.693 293.71 123.08C293.483 123.453 293.37 123.893 293.37 124.4C293.37 124.92 293.483 125.373 293.71 125.76C293.95 126.147 294.27 126.447 294.67 126.66C295.083 126.873 295.55 126.98 296.07 126.98Z"
      fill="#2182DF"
    />
    <path
      d="M236.096 155V153.26C236.989 152.553 237.842 151.847 238.656 151.14C239.469 150.433 240.202 149.733 240.856 149.04C241.509 148.347 242.022 147.667 242.396 147C242.769 146.333 242.956 145.693 242.956 145.08C242.956 144.68 242.882 144.307 242.736 143.96C242.589 143.613 242.356 143.333 242.036 143.12C241.729 142.907 241.316 142.8 240.796 142.8C240.289 142.8 239.856 142.913 239.496 143.14C239.149 143.367 238.889 143.673 238.716 144.06C238.542 144.433 238.456 144.86 238.456 145.34H236.136C236.162 144.327 236.382 143.48 236.796 142.8C237.209 142.12 237.769 141.613 238.476 141.28C239.182 140.933 239.976 140.76 240.856 140.76C241.802 140.76 242.609 140.933 243.276 141.28C243.942 141.627 244.456 142.113 244.816 142.74C245.176 143.367 245.356 144.107 245.356 144.96C245.356 145.587 245.236 146.207 244.996 146.82C244.769 147.42 244.449 148.007 244.036 148.58C243.622 149.14 243.156 149.687 242.636 150.22C242.129 150.74 241.602 151.24 241.056 151.72C240.509 152.187 239.982 152.62 239.476 153.02H245.736V155H236.096ZM249.659 155V143.74L247.179 144.38V142.52L250.619 141H252.119V155H249.659ZM259.472 155.24C258.565 155.24 257.738 155.08 256.992 154.76C256.245 154.427 255.645 153.927 255.192 153.26C254.752 152.58 254.518 151.727 254.492 150.7H256.852C256.865 151.167 256.972 151.593 257.172 151.98C257.385 152.353 257.685 152.653 258.072 152.88C258.458 153.093 258.925 153.2 259.472 153.2C259.992 153.2 260.432 153.1 260.792 152.9C261.165 152.7 261.445 152.427 261.632 152.08C261.818 151.733 261.912 151.347 261.912 150.92C261.912 150.4 261.785 149.973 261.532 149.64C261.278 149.293 260.932 149.033 260.492 148.86C260.052 148.687 259.552 148.6 258.992 148.6H257.952V146.62H258.992C259.725 146.62 260.325 146.453 260.792 146.12C261.258 145.773 261.492 145.273 261.492 144.62C261.492 144.073 261.312 143.633 260.952 143.3C260.605 142.967 260.105 142.8 259.452 142.8C258.772 142.8 258.232 143 257.832 143.4C257.445 143.8 257.232 144.293 257.192 144.88H254.832C254.872 144.04 255.085 143.313 255.472 142.7C255.872 142.073 256.412 141.593 257.092 141.26C257.772 140.927 258.565 140.76 259.472 140.76C260.418 140.76 261.218 140.927 261.872 141.26C262.525 141.593 263.018 142.04 263.352 142.6C263.698 143.16 263.872 143.773 263.872 144.44C263.872 144.96 263.772 145.433 263.572 145.86C263.372 146.287 263.098 146.647 262.752 146.94C262.418 147.22 262.025 147.427 261.572 147.56C262.092 147.667 262.552 147.873 262.952 148.18C263.365 148.487 263.685 148.88 263.912 149.36C264.152 149.827 264.272 150.373 264.272 151C264.272 151.76 264.085 152.467 263.712 153.12C263.352 153.76 262.812 154.273 262.092 154.66C261.385 155.047 260.512 155.24 259.472 155.24ZM273.284 155V152.34H266.344V150.42L272.944 141H275.664V150.24H277.564V152.34H275.664V155H273.284ZM268.924 150.24H273.424V143.64L268.924 150.24ZM280.618 155.1C280.165 155.1 279.798 154.96 279.518 154.68C279.238 154.4 279.098 154.067 279.098 153.68C279.098 153.267 279.238 152.92 279.518 152.64C279.798 152.36 280.165 152.22 280.618 152.22C281.058 152.22 281.418 152.36 281.698 152.64C281.978 152.92 282.118 153.267 282.118 153.68C282.118 154.067 281.978 154.4 281.698 154.68C281.418 154.96 281.058 155.1 280.618 155.1ZM289.305 155.24C288.305 155.24 287.438 155.067 286.705 154.72C285.985 154.36 285.418 153.873 285.005 153.26C284.592 152.633 284.345 151.927 284.265 151.14H286.605C286.725 151.727 287.025 152.22 287.505 152.62C287.985 153.007 288.585 153.2 289.305 153.2C289.852 153.2 290.318 153.073 290.705 152.82C291.092 152.553 291.392 152.2 291.605 151.76C291.832 151.307 291.945 150.8 291.945 150.24C291.945 149.667 291.832 149.167 291.605 148.74C291.392 148.313 291.092 147.987 290.705 147.76C290.318 147.52 289.872 147.4 289.365 147.4C288.738 147.4 288.198 147.547 287.745 147.84C287.305 148.12 286.985 148.473 286.785 148.9H284.465L285.625 141H293.345V143.1H287.425L286.785 146.56C287.092 146.227 287.498 145.96 288.005 145.76C288.512 145.547 289.092 145.44 289.745 145.44C290.478 145.44 291.125 145.567 291.685 145.82C292.245 146.073 292.718 146.42 293.105 146.86C293.492 147.3 293.778 147.813 293.965 148.4C294.165 148.973 294.265 149.58 294.265 150.22C294.265 150.94 294.145 151.607 293.905 152.22C293.665 152.82 293.325 153.347 292.885 153.8C292.458 154.253 291.938 154.607 291.325 154.86C290.725 155.113 290.052 155.24 289.305 155.24ZM301.928 155.24C300.888 155.24 300.008 155.047 299.288 154.66C298.581 154.273 298.015 153.76 297.588 153.12C297.161 152.467 296.848 151.74 296.648 150.94C296.448 150.14 296.348 149.32 296.348 148.48C296.348 146.92 296.568 145.567 297.008 144.42C297.448 143.26 298.075 142.36 298.888 141.72C299.715 141.08 300.708 140.76 301.868 140.76C302.828 140.76 303.635 140.947 304.288 141.32C304.955 141.68 305.475 142.16 305.848 142.76C306.221 143.36 306.448 144.013 306.528 144.72H304.288C304.168 144.093 303.895 143.613 303.468 143.28C303.055 142.933 302.515 142.76 301.848 142.76C301.248 142.76 300.715 142.947 300.248 143.32C299.781 143.693 299.415 144.253 299.148 145C298.881 145.747 298.728 146.693 298.688 147.84C298.688 147.867 298.688 147.893 298.688 147.92C298.688 147.933 298.688 147.953 298.688 147.98C298.901 147.593 299.188 147.253 299.548 146.96C299.908 146.653 300.321 146.413 300.788 146.24C301.268 146.067 301.781 145.98 302.328 145.98C303.115 145.98 303.841 146.167 304.508 146.54C305.188 146.9 305.735 147.42 306.148 148.1C306.575 148.78 306.788 149.58 306.788 150.5C306.788 151.34 306.588 152.12 306.188 152.84C305.788 153.56 305.221 154.14 304.488 154.58C303.755 155.02 302.901 155.24 301.928 155.24ZM301.788 153.18C302.308 153.18 302.768 153.067 303.168 152.84C303.568 152.613 303.881 152.307 304.108 151.92C304.348 151.533 304.468 151.093 304.468 150.6C304.468 150.08 304.348 149.627 304.108 149.24C303.881 148.853 303.561 148.553 303.148 148.34C302.748 148.127 302.288 148.02 301.768 148.02C301.261 148.02 300.801 148.133 300.388 148.36C299.988 148.573 299.668 148.873 299.428 149.26C299.188 149.647 299.068 150.087 299.068 150.58C299.068 151.087 299.188 151.533 299.428 151.92C299.668 152.307 299.988 152.613 300.388 152.84C300.801 153.067 301.268 153.18 301.788 153.18Z"
      fill="#FF6600"
    />
    <path
      d="M240.418 175.24C239.472 175.24 238.665 175.06 237.998 174.7C237.345 174.327 236.832 173.84 236.458 173.24C236.085 172.627 235.865 171.973 235.798 171.28H238.018C238.138 171.907 238.405 172.393 238.818 172.74C239.245 173.073 239.792 173.24 240.458 173.24C241.072 173.24 241.605 173.06 242.058 172.7C242.512 172.327 242.872 171.773 243.138 171.04C243.418 170.293 243.572 169.36 243.598 168.24C243.598 168.213 243.598 168.18 243.598 168.14C243.598 168.1 243.598 168.06 243.598 168.02C243.398 168.393 243.118 168.733 242.758 169.04C242.398 169.347 241.978 169.587 241.498 169.76C241.032 169.933 240.525 170.02 239.978 170.02C239.205 170.02 238.472 169.84 237.778 169.48C237.098 169.107 236.552 168.58 236.138 167.9C235.725 167.22 235.518 166.42 235.518 165.5C235.518 164.66 235.718 163.88 236.118 163.16C236.518 162.44 237.085 161.86 237.818 161.42C238.552 160.98 239.398 160.76 240.358 160.76C241.412 160.76 242.292 160.953 242.998 161.34C243.718 161.727 244.292 162.247 244.718 162.9C245.145 163.54 245.452 164.26 245.638 165.06C245.838 165.86 245.938 166.68 245.938 167.52C245.938 169.067 245.718 170.42 245.278 171.58C244.852 172.74 244.225 173.64 243.398 174.28C242.585 174.92 241.592 175.24 240.418 175.24ZM240.538 167.98C241.045 167.98 241.498 167.873 241.898 167.66C242.312 167.433 242.638 167.127 242.878 166.74C243.118 166.34 243.238 165.9 243.238 165.42C243.238 164.913 243.118 164.467 242.878 164.08C242.638 163.68 242.312 163.373 241.898 163.16C241.498 162.933 241.038 162.82 240.518 162.82C239.998 162.82 239.538 162.933 239.138 163.16C238.738 163.387 238.418 163.693 238.178 164.08C237.952 164.453 237.838 164.893 237.838 165.4C237.838 165.92 237.952 166.373 238.178 166.76C238.418 167.147 238.738 167.447 239.138 167.66C239.552 167.873 240.018 167.98 240.538 167.98ZM254.775 175V172.34H247.835V170.42L254.435 161H257.155V170.24H259.055V172.34H257.155V175H254.775ZM250.415 170.24H254.915V163.64L250.415 170.24ZM266.069 175.24C265.069 175.24 264.202 175.067 263.469 174.72C262.749 174.36 262.182 173.873 261.769 173.26C261.355 172.633 261.109 171.927 261.029 171.14H263.369C263.489 171.727 263.789 172.22 264.269 172.62C264.749 173.007 265.349 173.2 266.069 173.2C266.615 173.2 267.082 173.073 267.469 172.82C267.855 172.553 268.155 172.2 268.369 171.76C268.595 171.307 268.709 170.8 268.709 170.24C268.709 169.667 268.595 169.167 268.369 168.74C268.155 168.313 267.855 167.987 267.469 167.76C267.082 167.52 266.635 167.4 266.129 167.4C265.502 167.4 264.962 167.547 264.509 167.84C264.069 168.12 263.749 168.473 263.549 168.9H261.229L262.389 161H270.109V163.1H264.189L263.549 166.56C263.855 166.227 264.262 165.96 264.769 165.76C265.275 165.547 265.855 165.44 266.509 165.44C267.242 165.44 267.889 165.567 268.449 165.82C269.009 166.073 269.482 166.42 269.869 166.86C270.255 167.3 270.542 167.813 270.729 168.4C270.929 168.973 271.029 169.58 271.029 170.22C271.029 170.94 270.909 171.607 270.669 172.22C270.429 172.82 270.089 173.347 269.649 173.8C269.222 174.253 268.702 174.607 268.089 174.86C267.489 175.113 266.815 175.24 266.069 175.24ZM272.976 175V173.26C273.87 172.553 274.723 171.847 275.536 171.14C276.35 170.433 277.083 169.733 277.736 169.04C278.39 168.347 278.903 167.667 279.276 167C279.65 166.333 279.836 165.693 279.836 165.08C279.836 164.68 279.763 164.307 279.616 163.96C279.47 163.613 279.236 163.333 278.916 163.12C278.61 162.907 278.196 162.8 277.676 162.8C277.17 162.8 276.736 162.913 276.376 163.14C276.03 163.367 275.77 163.673 275.596 164.06C275.423 164.433 275.336 164.86 275.336 165.34H273.016C273.043 164.327 273.263 163.48 273.676 162.8C274.09 162.12 274.65 161.613 275.356 161.28C276.063 160.933 276.856 160.76 277.736 160.76C278.683 160.76 279.49 160.933 280.156 161.28C280.823 161.627 281.336 162.113 281.696 162.74C282.056 163.367 282.236 164.107 282.236 164.96C282.236 165.587 282.116 166.207 281.876 166.82C281.65 167.42 281.33 168.007 280.916 168.58C280.503 169.14 280.036 169.687 279.516 170.22C279.01 170.74 278.483 171.24 277.936 171.72C277.39 172.187 276.863 172.62 276.356 173.02H282.616V175H272.976ZM284.519 175V173.26C285.413 172.553 286.266 171.847 287.079 171.14C287.893 170.433 288.626 169.733 289.279 169.04C289.933 168.347 290.446 167.667 290.819 167C291.193 166.333 291.379 165.693 291.379 165.08C291.379 164.68 291.306 164.307 291.159 163.96C291.013 163.613 290.779 163.333 290.459 163.12C290.153 162.907 289.739 162.8 289.219 162.8C288.713 162.8 288.279 162.913 287.919 163.14C287.573 163.367 287.313 163.673 287.139 164.06C286.966 164.433 286.879 164.86 286.879 165.34H284.559C284.586 164.327 284.806 163.48 285.219 162.8C285.633 162.12 286.193 161.613 286.899 161.28C287.606 160.933 288.399 160.76 289.279 160.76C290.226 160.76 291.033 160.933 291.699 161.28C292.366 161.627 292.879 162.113 293.239 162.74C293.599 163.367 293.779 164.107 293.779 164.96C293.779 165.587 293.659 166.207 293.419 166.82C293.193 167.42 292.873 168.007 292.459 168.58C292.046 169.14 291.579 169.687 291.059 170.22C290.553 170.74 290.026 171.24 289.479 171.72C288.933 172.187 288.406 172.62 287.899 173.02H294.159V175H284.519ZM297.362 175.1C296.909 175.1 296.542 174.96 296.262 174.68C295.982 174.4 295.842 174.067 295.842 173.68C295.842 173.267 295.982 172.92 296.262 172.64C296.542 172.36 296.909 172.22 297.362 172.22C297.802 172.22 298.162 172.36 298.442 172.64C298.722 172.92 298.862 173.267 298.862 173.68C298.862 174.067 298.722 174.4 298.442 174.68C298.162 174.96 297.802 175.1 297.362 175.1ZM305.669 175.24C304.762 175.24 303.936 175.08 303.189 174.76C302.442 174.427 301.842 173.927 301.389 173.26C300.949 172.58 300.716 171.727 300.689 170.7H303.049C303.062 171.167 303.169 171.593 303.369 171.98C303.582 172.353 303.882 172.653 304.269 172.88C304.656 173.093 305.122 173.2 305.669 173.2C306.189 173.2 306.629 173.1 306.989 172.9C307.362 172.7 307.642 172.427 307.829 172.08C308.016 171.733 308.109 171.347 308.109 170.92C308.109 170.4 307.982 169.973 307.729 169.64C307.476 169.293 307.129 169.033 306.689 168.86C306.249 168.687 305.749 168.6 305.189 168.6H304.149V166.62H305.189C305.922 166.62 306.522 166.453 306.989 166.12C307.456 165.773 307.689 165.273 307.689 164.62C307.689 164.073 307.509 163.633 307.149 163.3C306.802 162.967 306.302 162.8 305.649 162.8C304.969 162.8 304.429 163 304.029 163.4C303.642 163.8 303.429 164.293 303.389 164.88H301.029C301.069 164.04 301.282 163.313 301.669 162.7C302.069 162.073 302.609 161.593 303.289 161.26C303.969 160.927 304.762 160.76 305.669 160.76C306.616 160.76 307.416 160.927 308.069 161.26C308.722 161.593 309.216 162.04 309.549 162.6C309.896 163.16 310.069 163.773 310.069 164.44C310.069 164.96 309.969 165.433 309.769 165.86C309.569 166.287 309.296 166.647 308.949 166.94C308.616 167.22 308.222 167.427 307.769 167.56C308.289 167.667 308.749 167.873 309.149 168.18C309.562 168.487 309.882 168.88 310.109 169.36C310.349 169.827 310.469 170.373 310.469 171C310.469 171.76 310.282 172.467 309.909 173.12C309.549 173.76 309.009 174.273 308.289 174.66C307.582 175.047 306.709 175.24 305.669 175.24Z"
      fill="#2182DF"
    />
    <path
      d="M241.22 195V192.34H234.28V190.42L240.88 181H243.6V190.24H245.5V192.34H243.6V195H241.22ZM236.86 190.24H241.36V183.64L236.86 190.24ZM252.514 195.24C251.514 195.24 250.647 195.067 249.914 194.72C249.194 194.36 248.627 193.873 248.214 193.26C247.8 192.633 247.554 191.927 247.474 191.14H249.814C249.934 191.727 250.234 192.22 250.714 192.62C251.194 193.007 251.794 193.2 252.514 193.2C253.06 193.2 253.527 193.073 253.914 192.82C254.3 192.553 254.6 192.2 254.814 191.76C255.04 191.307 255.154 190.8 255.154 190.24C255.154 189.667 255.04 189.167 254.814 188.74C254.6 188.313 254.3 187.987 253.914 187.76C253.527 187.52 253.08 187.4 252.574 187.4C251.947 187.4 251.407 187.547 250.954 187.84C250.514 188.12 250.194 188.473 249.994 188.9H247.674L248.834 181H256.554V183.1H250.634L249.994 186.56C250.3 186.227 250.707 185.96 251.214 185.76C251.72 185.547 252.3 185.44 252.954 185.44C253.687 185.44 254.334 185.567 254.894 185.82C255.454 186.073 255.927 186.42 256.314 186.86C256.7 187.3 256.987 187.813 257.174 188.4C257.374 188.973 257.474 189.58 257.474 190.22C257.474 190.94 257.354 191.607 257.114 192.22C256.874 192.82 256.534 193.347 256.094 193.8C255.667 194.253 255.147 194.607 254.534 194.86C253.934 195.113 253.26 195.24 252.514 195.24ZM265.137 195.24C264.097 195.24 263.217 195.047 262.497 194.66C261.79 194.273 261.224 193.76 260.797 193.12C260.37 192.467 260.057 191.74 259.857 190.94C259.657 190.14 259.557 189.32 259.557 188.48C259.557 186.92 259.777 185.567 260.217 184.42C260.657 183.26 261.284 182.36 262.097 181.72C262.924 181.08 263.917 180.76 265.077 180.76C266.037 180.76 266.844 180.947 267.497 181.32C268.164 181.68 268.684 182.16 269.057 182.76C269.43 183.36 269.657 184.013 269.737 184.72H267.497C267.377 184.093 267.104 183.613 266.677 183.28C266.264 182.933 265.724 182.76 265.057 182.76C264.457 182.76 263.924 182.947 263.457 183.32C262.99 183.693 262.624 184.253 262.357 185C262.09 185.747 261.937 186.693 261.897 187.84C261.897 187.867 261.897 187.893 261.897 187.92C261.897 187.933 261.897 187.953 261.897 187.98C262.11 187.593 262.397 187.253 262.757 186.96C263.117 186.653 263.53 186.413 263.997 186.24C264.477 186.067 264.99 185.98 265.537 185.98C266.324 185.98 267.05 186.167 267.717 186.54C268.397 186.9 268.944 187.42 269.357 188.1C269.784 188.78 269.997 189.58 269.997 190.5C269.997 191.34 269.797 192.12 269.397 192.84C268.997 193.56 268.43 194.14 267.697 194.58C266.964 195.02 266.11 195.24 265.137 195.24ZM264.997 193.18C265.517 193.18 265.977 193.067 266.377 192.84C266.777 192.613 267.09 192.307 267.317 191.92C267.557 191.533 267.677 191.093 267.677 190.6C267.677 190.08 267.557 189.627 267.317 189.24C267.09 188.853 266.77 188.553 266.357 188.34C265.957 188.127 265.497 188.02 264.977 188.02C264.47 188.02 264.01 188.133 263.597 188.36C263.197 188.573 262.877 188.873 262.637 189.26C262.397 189.647 262.277 190.087 262.277 190.58C262.277 191.087 262.397 191.533 262.637 191.92C262.877 192.307 263.197 192.613 263.597 192.84C264.01 193.067 264.477 193.18 264.997 193.18ZM278.993 195V192.34H272.053V190.42L278.653 181H281.373V190.24H283.273V192.34H281.373V195H278.993ZM274.633 190.24H279.133V183.64L274.633 190.24ZM286.327 195.1C285.874 195.1 285.507 194.96 285.227 194.68C284.947 194.4 284.807 194.067 284.807 193.68C284.807 193.267 284.947 192.92 285.227 192.64C285.507 192.36 285.874 192.22 286.327 192.22C286.767 192.22 287.127 192.36 287.407 192.64C287.687 192.92 287.827 193.267 287.827 193.68C287.827 194.067 287.687 194.4 287.407 194.68C287.127 194.96 286.767 195.1 286.327 195.1ZM289.754 195V193.26C290.647 192.553 291.5 191.847 292.314 191.14C293.127 190.433 293.86 189.733 294.514 189.04C295.167 188.347 295.68 187.667 296.054 187C296.427 186.333 296.614 185.693 296.614 185.08C296.614 184.68 296.54 184.307 296.394 183.96C296.247 183.613 296.014 183.333 295.694 183.12C295.387 182.907 294.974 182.8 294.454 182.8C293.947 182.8 293.514 182.913 293.154 183.14C292.807 183.367 292.547 183.673 292.374 184.06C292.2 184.433 292.114 184.86 292.114 185.34H289.794C289.82 184.327 290.04 183.48 290.454 182.8C290.867 182.12 291.427 181.613 292.134 181.28C292.84 180.933 293.634 180.76 294.514 180.76C295.46 180.76 296.267 180.933 296.934 181.28C297.6 181.627 298.114 182.113 298.474 182.74C298.834 183.367 299.014 184.107 299.014 184.96C299.014 185.587 298.894 186.207 298.654 186.82C298.427 187.42 298.107 188.007 297.694 188.58C297.28 189.14 296.814 189.687 296.294 190.22C295.787 190.74 295.26 191.24 294.714 191.72C294.167 192.187 293.64 192.62 293.134 193.02H299.394V195H289.754ZM306.557 195.24C305.557 195.24 304.69 195.067 303.957 194.72C303.237 194.36 302.67 193.873 302.257 193.26C301.843 192.633 301.597 191.927 301.517 191.14H303.857C303.977 191.727 304.277 192.22 304.757 192.62C305.237 193.007 305.837 193.2 306.557 193.2C307.103 193.2 307.57 193.073 307.957 192.82C308.343 192.553 308.643 192.2 308.857 191.76C309.083 191.307 309.197 190.8 309.197 190.24C309.197 189.667 309.083 189.167 308.857 188.74C308.643 188.313 308.343 187.987 307.957 187.76C307.57 187.52 307.123 187.4 306.617 187.4C305.99 187.4 305.45 187.547 304.997 187.84C304.557 188.12 304.237 188.473 304.037 188.9H301.717L302.877 181H310.597V183.1H304.677L304.037 186.56C304.343 186.227 304.75 185.96 305.257 185.76C305.763 185.547 306.343 185.44 306.997 185.44C307.73 185.44 308.377 185.567 308.937 185.82C309.497 186.073 309.97 186.42 310.357 186.86C310.743 187.3 311.03 187.813 311.217 188.4C311.417 188.973 311.517 189.58 311.517 190.22C311.517 190.94 311.397 191.607 311.157 192.22C310.917 192.82 310.577 193.347 310.137 193.8C309.71 194.253 309.19 194.607 308.577 194.86C307.977 195.113 307.303 195.24 306.557 195.24Z"
      fill="#FF6600"
    />
    <path
      d="M888 148.116V213.231H942.941H997.883V200.005V186.778H995.848H993.813V197.97V209.162H987.708H981.604V201.022V192.883H978.552H975.499V190.873V188.838L976.975 188.686C990.837 187.134 1002.16 177.087 1005.31 163.504C1005.97 160.63 1006.23 154.627 1005.77 151.651C1004.95 145.954 1002.26 139.773 998.824 135.703L997.883 134.584V122.476V110.344L984.224 96.6845L970.539 83H951.539H932.513V85.0349V87.0697H949.936H967.36V100.296V113.523H980.586H993.813V122.044C993.813 126.724 993.737 130.565 993.66 130.565C993.584 130.565 993.075 130.234 992.567 129.853C989.769 127.64 984.758 125.376 980.637 124.435C977.738 123.774 971.887 123.519 969.217 123.926C955.023 126.139 944.442 136.059 941.492 149.896C940.856 152.923 940.856 159.613 941.492 162.614C942.891 169.151 945.816 174.594 950.42 179.249C955.634 184.54 962.374 187.77 969.98 188.686L971.43 188.838V190.873V192.883H968.377H965.325V201.022V209.162H928.697H892.07V148.116V87.0697H909.366H926.662V85.0349V83H907.331H888V148.116ZM981.222 99.7876L990.888 109.453H981.146H971.43V99.7876C971.43 94.4715 971.455 90.122 971.506 90.122C971.531 90.122 975.906 94.4715 981.222 99.7876ZM977.916 128.149C981.324 128.759 983.512 129.471 986.182 130.819C991.854 133.668 996.204 138.069 999.027 143.741C1002.64 150.99 1002.92 159.74 999.765 167.243C995.416 177.672 984.783 184.743 973.464 184.743C961.281 184.743 950.063 176.528 946.401 164.954C944.518 158.977 944.569 153.101 946.528 147.251C949.377 138.781 956.372 131.837 964.791 129.191C969.242 127.792 973.948 127.411 977.916 128.149ZM977.534 203.057V209.162H973.464H969.395V203.057V196.953H973.464H977.534V203.057Z"
      fill="white"
    />
    <path
      d="M970.032 131.988C968.226 132.293 965.072 133.234 963.342 134.023C961.129 135.04 957.95 137.101 957.95 137.508C957.95 137.686 958.509 138.449 959.196 139.212L960.443 140.585L961.816 139.67C964.665 137.787 968.836 136.16 970.846 136.16H971.431V147.224V158.289H982.623H993.814L993.662 159.103C992.543 165.284 989.465 170.066 984.505 173.296C980.791 175.738 976.874 176.781 972.448 176.526C966.878 176.196 962.554 174.161 958.637 169.989C952.379 163.325 951.438 153.736 956.246 145.545L956.932 144.401L955.355 143.282C953.473 141.959 953.371 142.01 952.023 144.477C944.138 159.154 952.71 177.238 969.014 180.291C971.99 180.85 976.798 180.698 979.697 179.935C986.692 178.129 992.95 172.813 995.798 166.301C997.452 162.537 997.757 160.883 997.731 156.127C997.706 152.184 997.655 151.599 997.019 149.539C994.501 141.247 987.888 134.761 979.697 132.599C977.688 132.064 971.914 131.708 970.032 131.988ZM980.893 137.381C985.649 139.212 989.923 143.256 992.034 147.962C992.721 149.437 993.306 151.447 993.662 153.38L993.814 154.219H984.657H975.501V145.088V135.956L977.23 136.287C978.197 136.49 979.85 136.974 980.893 137.381Z"
      fill="#FF6600"
    />
    <path
      d="M963.295 156.254V158.289H965.457H967.619V156.254V154.219H965.457H963.295V156.254Z"
      fill="#FF6600"
    />
    <path
      d="M971.43 164.396V166.431H973.592H975.754V164.396V162.361H973.592H971.43V164.396Z"
      fill="#FF6600"
    />
    <path
      d="M979.562 164.396V166.431H981.725H983.887V164.396V162.361H981.725H979.562V164.396Z"
      fill="#FF6600"
    />
    <path
      d="M896.135 108.439V125.735H898.17H900.204V110.474V95.2123H904.274H908.344V93.1775V91.1426H902.239H896.135V108.439Z"
      fill="#2182DF"
    />
    <path
      d="M912.166 93.1761V95.2109H914.328H916.49V93.1761V91.1412H914.328H912.166V93.1761Z"
      fill="#2182DF"
    />
    <path
      d="M920.301 93.1761V95.2109H922.463H924.625V93.1761V91.1412H922.463H920.301V93.1761Z"
      fill="#2182DF"
    />
    <path
      d="M928.434 93.1761V95.2109H930.596H932.758V93.1761V91.1412H930.596H928.434V93.1761Z"
      fill="#2182DF"
    />
    <path
      d="M896.135 139.977V148.116H914.449H932.762V139.977V131.837H914.449H896.135V139.977ZM928.693 139.977V144.046H914.449H900.204V139.977V135.907H914.449H928.693V139.977Z"
      fill="#FF6600"
    />
    <path
      d="M901.994 156.254V158.289H917.383H932.771V156.254V154.219H917.383H901.994V156.254Z"
      fill="#2182DF"
    />
    <path
      d="M906.053 164.396V166.431H919.407H932.76V164.396V162.361H919.407H906.053V164.396Z"
      fill="#2182DF"
    />
    <path
      d="M906.053 172.536V174.571H919.407H932.76V172.536V170.502H919.407H906.053V172.536Z"
      fill="#2182DF"
    />
    <path
      d="M906.053 180.672V182.707H919.407H932.76V180.672V178.637H919.407H906.053V180.672Z"
      fill="#2182DF"
    />
    <path
      d="M912.166 188.815V190.85H914.328H916.49V188.815V186.78H914.328H912.166V188.815Z"
      fill="#2182DF"
    />
    <path
      d="M920.301 188.815V190.85H922.463H924.625V188.815V186.78H922.463H920.301V188.815Z"
      fill="#2182DF"
    />
    <path
      d="M928.434 188.815V190.85H930.596H932.758V188.815V186.78H930.596H928.434V188.815Z"
      fill="#2182DF"
    />
    <path
      d="M896.135 200.004V205.091H916.483H936.832V203.056V201.021H918.518H900.205V197.969V194.916H898.17H896.135V200.004Z"
      fill="#2182DF"
    />
    <path
      d="M940.645 203.056V205.091H942.807H944.969V203.056V201.021H942.807H940.645V203.056Z"
      fill="#2182DF"
    />
    <path
      d="M948.795 203.056V205.091H950.957H953.119V203.056V201.021H950.957H948.795V203.056Z"
      fill="#2182DF"
    />
    <path
      d="M5.42609 91.5478C3.6 92.2522 1.64348 94.1565 0.730435 96.087L0 97.6522V151V204.348L0.730435 205.913C1.66957 207.896 3.6 209.748 5.50435 210.478C6.91304 211 7.27826 211 45 211C82.7217 211 83.087 211 84.4957 210.478C86.4 209.748 88.3304 207.896 89.2696 205.913L90 204.348L90.0783 159.739L90.1304 115.157L78.0783 103.078L66 91L36.3913 91.0261C7.46087 91.0261 6.75652 91.0261 5.42609 91.5478ZM63.8348 103.052C63.913 111.922 63.9391 112.287 64.487 113.304C65.2174 114.687 66.5217 115.887 67.9565 116.539C69.0522 117.035 69.6522 117.087 78.0783 117.087H87V149.565V185.174H45H3V140.252V98.4609L3.54783 97.3391C4.17391 96.0609 5.66087 94.7044 6.93913 94.2348C7.61739 93.9739 14.5304 93.8957 35.7913 93.8957L63.7565 93.8696L63.8348 103.052ZM77.9478 114.165C74.087 114.191 70.5652 114.165 70.0956 114.087C68.8174 113.852 67.3044 112.365 66.9391 110.957C66.7565 110.252 66.6522 107.096 66.6522 102.817V95.8261L75.7826 104.957L84.913 114.087L77.9478 114.165ZM87 194.304C87 201.4 86.9217 203.643 86.6609 204.296C86.087 205.652 84.887 206.852 83.4783 207.504L82.1739 208.13H45H7.82609L6.52174 207.504C5.11304 206.852 3.91304 205.652 3.33913 204.296C3.07826 203.643 3 201.4 3 194.304V185.174H45H87V194.304Z"
      fill="white"
    />
    <path
      d="M5.42609 91.5478C3.6 92.2522 1.64348 94.1565 0.730435 96.087L0 97.6522V151V204.348L0.730435 205.913C1.66957 207.896 3.6 209.748 5.50435 210.478C6.91304 211 7.27826 211 45 211C82.7217 211 83.087 211 84.4957 210.478C86.4 209.748 88.3304 207.896 89.2696 205.913L90 204.348L90.0783 159.739L90.1304 115.157L78.0783 103.078L66 91L36.3913 91.0261C7.46087 91.0261 6.75652 91.0261 5.42609 91.5478ZM63.8348 103.052C63.913 111.922 63.9391 112.287 64.487 113.304C65.2174 114.687 66.5217 115.887 67.9565 116.539C69.0522 117.035 69.6522 117.087 78.0783 117.087H87V149.565V185.174H45H3V140.252V98.4609L3.54783 97.3391C4.17391 96.0609 5.66087 94.7044 6.93913 94.2348C7.61739 93.9739 14.5304 93.8957 35.7913 93.8957L63.7565 93.8696L63.8348 103.052ZM77.9478 114.165C74.087 114.191 70.5652 114.165 70.0956 114.087C68.8174 113.852 67.3044 112.365 66.9391 110.957C66.7565 110.252 66.6522 107.096 66.6522 102.817V95.8261L75.7826 104.957L84.913 114.087L77.9478 114.165ZM87 194.304C87 201.4 86.9217 203.643 86.6609 204.296C86.087 205.652 84.887 206.852 83.4783 207.504L82.1739 208.13H45H7.82609L6.52174 207.504C5.11304 206.852 3.91304 205.652 3.33913 204.296C3.07826 203.643 3 201.4 3 194.304V185.174H45H87V194.304Z"
      fill="white"
    />
    <path d="M11 107H57" stroke="#FF6600" />
    <path d="M11 118H57" stroke="#FF6600" />
    <path d="M11 129H76" stroke="#2182DF" />
    <path d="M11 140H57" stroke="#FF6600" />
    <path d="M11 151H76" stroke="#2182DF" />
    <path d="M11 162H76" stroke="#2182DF" />
    <path d="M11 173H76" stroke="#2182DF" />
    <path d="M11 184H57" stroke="#FF6600" />
    <path d="M11 195H52" stroke="#FF6600" />
    <path
      d="M715.46 53.168C714.517 53.168 713.682 52.958 712.954 52.538C712.235 52.1087 711.671 51.516 711.26 50.76C710.849 49.9947 710.644 49.108 710.644 48.1C710.644 47.1013 710.849 46.224 711.26 45.468C711.671 44.7027 712.235 44.1053 712.954 43.676C713.682 43.2467 714.517 43.032 715.46 43.032C716.421 43.032 717.266 43.2467 717.994 43.676C718.722 44.1053 719.287 44.7027 719.688 45.468C720.089 46.224 720.29 47.1013 720.29 48.1C720.29 49.108 720.089 49.9947 719.688 50.76C719.287 51.516 718.722 52.1087 717.994 52.538C717.266 52.958 716.421 53.168 715.46 53.168ZM715.474 51.656C716.099 51.656 716.645 51.516 717.112 51.236C717.579 50.9467 717.938 50.536 718.19 50.004C718.442 49.472 718.568 48.8373 718.568 48.1C718.568 47.3627 718.442 46.728 718.19 46.196C717.938 45.664 717.579 45.258 717.112 44.978C716.645 44.6887 716.099 44.544 715.474 44.544C714.849 44.544 714.303 44.6887 713.836 44.978C713.369 45.258 713.005 45.664 712.744 46.196C712.492 46.728 712.366 47.3627 712.366 48.1C712.366 48.8373 712.492 49.472 712.744 50.004C713.005 50.536 713.369 50.9467 713.836 51.236C714.303 51.516 714.849 51.656 715.474 51.656ZM724.494 53.168C723.924 53.168 723.434 53.056 723.024 52.832C722.622 52.5987 722.314 52.2533 722.1 51.796C721.885 51.3293 721.778 50.7553 721.778 50.074V45.944H723.458V49.906C723.458 50.5127 723.584 50.9747 723.836 51.292C724.097 51.6 724.489 51.754 725.012 51.754C725.348 51.754 725.646 51.6747 725.908 51.516C726.178 51.3573 726.388 51.1287 726.538 50.83C726.696 50.522 726.776 50.1487 726.776 49.71V45.944H728.456V53H726.972L726.846 51.824C726.631 52.2347 726.318 52.5613 725.908 52.804C725.506 53.0467 725.035 53.168 724.494 53.168ZM733.391 53C732.915 53 732.499 52.9253 732.145 52.776C731.799 52.6267 731.529 52.3793 731.333 52.034C731.137 51.6887 731.039 51.222 731.039 50.634V47.358H729.835V45.944H731.039L731.235 44.082H732.719V45.944H734.637V47.358H732.719V50.634C732.719 50.9887 732.793 51.236 732.943 51.376C733.101 51.5067 733.363 51.572 733.727 51.572H734.595V53H733.391ZM736.217 56.08V45.944H737.715L737.897 46.966C738.047 46.7607 738.224 46.5693 738.429 46.392C738.644 46.2053 738.901 46.056 739.199 45.944C739.507 45.832 739.857 45.776 740.249 45.776C740.912 45.776 741.495 45.9393 741.999 46.266C742.513 46.5927 742.914 47.036 743.203 47.596C743.493 48.1467 743.637 48.7767 743.637 49.486C743.637 50.1953 743.488 50.83 743.189 51.39C742.9 51.9407 742.499 52.3747 741.985 52.692C741.481 53.0093 740.903 53.168 740.249 53.168C739.717 53.168 739.251 53.07 738.849 52.874C738.457 52.6687 738.14 52.3793 737.897 52.006V56.08H736.217ZM739.899 51.712C740.291 51.712 740.641 51.6187 740.949 51.432C741.257 51.2453 741.495 50.984 741.663 50.648C741.841 50.312 741.929 49.9247 741.929 49.486C741.929 49.038 741.841 48.646 741.663 48.31C741.495 47.974 741.257 47.7127 740.949 47.526C740.641 47.3393 740.291 47.246 739.899 47.246C739.498 47.246 739.143 47.3393 738.835 47.526C738.537 47.7127 738.299 47.974 738.121 48.31C737.953 48.646 737.869 49.0333 737.869 49.472C737.869 49.92 737.953 50.312 738.121 50.648C738.299 50.9747 738.537 51.236 738.835 51.432C739.143 51.6187 739.498 51.712 739.899 51.712ZM747.886 53.168C747.317 53.168 746.827 53.056 746.416 52.832C746.015 52.5987 745.707 52.2533 745.492 51.796C745.277 51.3293 745.17 50.7553 745.17 50.074V45.944H746.85V49.906C746.85 50.5127 746.976 50.9747 747.228 51.292C747.489 51.6 747.881 51.754 748.404 51.754C748.74 51.754 749.039 51.6747 749.3 51.516C749.571 51.3573 749.781 51.1287 749.93 50.83C750.089 50.522 750.168 50.1487 750.168 49.71V45.944H751.848V53H750.364L750.238 51.824C750.023 52.2347 749.711 52.5613 749.3 52.804C748.899 53.0467 748.427 53.168 747.886 53.168ZM756.783 53C756.307 53 755.892 52.9253 755.537 52.776C755.192 52.6267 754.921 52.3793 754.725 52.034C754.529 51.6887 754.431 51.222 754.431 50.634V47.358H753.227V45.944H754.431L754.627 44.082H756.111V45.944H758.029V47.358H756.111V50.634C756.111 50.9887 756.186 51.236 756.335 51.376C756.494 51.5067 756.755 51.572 757.119 51.572H757.987V53H756.783Z"
      fill="white"
    />
    <rect
      x={449}
      y={61}
      width={15.4491}
      height={15.4492}
      fill="url(#paint0_linear_418_1601)"
    />
    <rect
      x={510.281}
      y={61.515}
      width={14.4191}
      height={14.4193}
      fill="url(#paint1_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M571.046 61.515H585.465V75.9342H571.046V61.515Z"
      fill="url(#paint2_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M631.812 61.515H646.231V75.9342H631.812V61.515Z"
      fill="url(#paint3_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M631.812 86.2318H646.231V100.651H631.812V86.2318Z"
      fill="url(#paint4_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M631.812 110.95H646.231V125.369H631.812V110.95Z"
      fill="url(#paint5_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M631.812 135.669H646.231V150.089H631.812V135.669Z"
      fill="url(#paint6_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M630.269 160.389H644.688V174.808H630.269V160.389Z"
      fill="url(#paint7_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M464.447 68.4658H509.507"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.447 94.2148H509.507"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M571.046 86.2318H585.465V100.651H571.046V86.2318Z"
      fill="url(#paint8_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M571.046 110.95H585.465V125.369H571.046V110.95Z"
      fill="url(#paint9_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M571.046 135.669H585.465V150.089H571.046V135.669Z"
      fill="url(#paint10_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M571.046 160.389H585.465V174.808H571.046V160.389Z"
      fill="url(#paint11_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M571.046 185.107H585.465V199.526H571.046V185.107Z"
      fill="url(#paint12_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M571.046 209.827H585.465V224.247H571.046V209.827Z"
      fill="url(#paint13_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M571.046 234.544H585.465V248.964H571.046V234.544Z"
      fill="url(#paint14_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M510.281 86.2318H524.7V100.651H510.281V86.2318Z"
      fill="url(#paint15_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M510.281 110.95H524.7V125.369H510.281V110.95Z"
      fill="url(#paint16_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M510.281 135.669H524.7V150.089H510.281V135.669Z"
      fill="url(#paint17_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M510.281 160.389H524.7V174.808H510.281V160.389Z"
      fill="url(#paint18_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M510.281 185.107H524.7V199.526H510.281V185.107Z"
      fill="url(#paint19_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M510.281 209.827H524.7V224.247H510.281V209.827Z"
      fill="url(#paint20_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <path
      d="M510.281 234.544H524.7V248.964H510.281V234.544Z"
      fill="url(#paint21_linear_418_1601)"
      stroke="black"
      strokeWidth={1.02994}
    />
    <rect
      x={449}
      y={85.7168}
      width={15.4491}
      height={15.4492}
      fill="url(#paint22_linear_418_1601)"
    />
    <path
      d="M464.447 68.207L509.764 93.9557"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.447 93.957L509.764 119.706"
      stroke="white"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.447 93.957L509.764 119.706"
      stroke="white"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.447 93.957L509.764 119.706"
      stroke="white"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.447 93.957L509.764 119.706"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.193 93.957L510.026 68.4658"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.447 94.2148L509.764 143.652"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.447 94.2148L510.022 168.114"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.965 94.2148L510.797 193.09"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M465.227 94.2148L510.029 218.324"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.709 93.7002L509.769 242.27"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.193 68.7227L509.511 119.448"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.965 69.2393L510.025 142.366"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.193 70.0107L509.768 167.598"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M464.709 70.5244L509.769 191.801"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M463.934 70.7832L510.281 218.066"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M524.701 69.7529H570.791"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.99 95.2441L570.278 69.7529"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.73 118.419H570.275"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.73 142.364L570.275 168.113"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M524.959 143.136L570.534 193.088"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M524.441 143.909L570.274 118.16"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.477 118.161L570.279 93.7002"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.73 94.9863L569.503 117.645"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.215 94.9863L570.017 143.394"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.477 168.627L570.794 143.136"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.215 168.627L570.017 193.346"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.215 168.887L570.275 217.552"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.215 191.544L570.532 168.37"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.215 191.801L570.275 217.807"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M524.959 217.035L570.534 168.37"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M525.215 217.035L570.532 243.041"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M524.959 241.498L570.019 218.324"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M524.959 241.497L569.761 243.299"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M570.794 94.7295L525.477 192.317"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M570.791 143.136H524.701"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M570.279 93.7002L525.477 142.88"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.24 242.783L631.815 119.704L586.24 68.9795"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M587.271 243.3L630.529 94.7298L587.271 71.041"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.756 244.585L630.528 70.2666H586.756L630.528 144.68"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.496 117.128L630.268 144.679L586.496 168.368H630.268"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.496 192.831L629.238 169.142L586.496 141.076"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M585.727 93.1846L631.044 144.682"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.24 217.037L628.983 169.145"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M585.727 216.777L631.301 119.447"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M585.727 193.088L631.559 119.189"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M585.982 168.885L631.3 120.22"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.756 142.88L631.558 118.676"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.496 117.646H630.783"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.24 94.7295L631.3 119.448"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.24 69.4951L630.528 119.19"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M587.012 95.2438L631.042 69.4951L587.012 118.933"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M585.469 144.167L631.301 70.7832L585.469 168.113"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M587.012 193.862L631.299 71.041L587.012 218.324"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M585.727 93.1846L630.529 95.502L585.727 117.903"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M586.24 143.137L630.528 96.0166L586.24 169.4"
      stroke="#2182DF"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M645.205 168.628L676.618 96.2744L645.205 143.395"
      stroke="#FF6600"
      strokeWidth={0.514972}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M646.49 118.933L675.843 96.5319L646.49 93.957"
      stroke="#FF6600"
      strokeWidth={2.05989}
      strokeDasharray="4.12 4.12"
    />
    <path
      d="M645.977 69.2393C649.066 69.2393 667.691 87.0917 676.617 96.0179"
      stroke="#FF6600"
      strokeWidth={1.02994}
      strokeDasharray="4.12 4.12"
    />
    <g clipPath="url(#clip0_418_1601)">
      <rect
        width={115}
        height={109}
        transform="translate(678 61)"
        fill="#2182DF"
      />
      <g filter="url(#filter0_f_418_1601)">
        <path
          d="M735 113.5L737.5 113.5L739.5 113.5V119.5L736.5 121L733.5 122L730.5 119.5C730.167 119.167 729.2 118.2 728 117C726.5 115.5 723 112 723 111C723 110 721.5 107 722 106L725 100L727 97.0002L734.5 94.0002H742C743.166 93.8335 745.699 93.6002 746.5 94.0002C747.5 94.5002 749 97.0002 750.5 97.0002C752 97.0002 754 98.9998 755 99.5C755.8 99.9001 759 106 760.5 109L762 112.5V118.5V123.5C762 124 760.5 128 760.5 128.5V130.5C760.5 131.5 759.5 133 759.5 134.5C759.5 135.7 758.833 137 758.5 137.5L757 140.5L755.5 142L749 144L743 147C741.167 147 737.3 147.1 736.5 147.5C735.7 147.9 729.833 148 727 148H717.5C716.833 147.167 715.399 145.3 715 144.5C714.5 143.5 710 137.5 709.5 136C709 134.5 706 129.5 705.5 129C705 128.5 701 124.5 701 124C701 123.6 699.333 120.833 698.5 119.5L696.5 117L694 110L695 107L701 106.6L706 107L708 110C709 112.5 711.1 117.7 711.5 118.5C712 119.5 714 123 715 124.5C715.8 125.7 718 127.667 719 128.5L726.5 134.5L734.5 135.5L744.5 132.5L748.5 128.5L750.5 122.5L752 117L751 110L746.5 106L739 104.5L735.5 106.5L734 109L733.5 111.5L735 113.5Z"
          fill="#FF7A33"
        />
        <path
          d="M699.752 106.5L701 106.6M701 106.6L706 107L708 110C709 112.5 711.1 117.7 711.5 118.5C712 119.5 714 123 715 124.5C715.8 125.7 718 127.667 719 128.5L726.5 134.5L734.5 135.5L744.5 132.5L748.5 128.5L750.5 122.5L752 117L751 110L746.5 106L739 104.5L735.5 106.5L734 109L733.5 111.5L735 113.5L737.5 113.5L739.5 113.5V119.5L736.5 121L733.5 122L730.5 119.5C730.167 119.167 729.2 118.2 728 117C726.5 115.5 723 112 723 111C723 110 721.5 107 722 106C722.4 105.2 724.167 101.667 725 100L727 97.0002L734.5 94.0002H742C743.166 93.8335 745.699 93.6002 746.5 94.0002C747.5 94.5002 749 97.0002 750.5 97.0002C752 97.0002 754 98.9998 755 99.5C755.8 99.9001 759 106 760.5 109L762 112.5V118.5C762 120 762 123.1 762 123.5C762 124 760.5 128 760.5 128.5C760.5 129 760.5 129.5 760.5 130.5C760.5 131.5 759.5 133 759.5 134.5C759.5 135.7 758.833 137 758.5 137.5L757 140.5L755.5 142L749 144L743 147C741.167 147 737.3 147.1 736.5 147.5C735.7 147.9 729.833 148 727 148H717.5C716.833 147.167 715.399 145.3 715 144.5C714.5 143.5 710 137.5 709.5 136C709 134.5 706 129.5 705.5 129C705 128.5 701 124.5 701 124C701 123.6 699.333 120.833 698.5 119.5L696.5 117L694 110L695 107L701 106.6Z"
          stroke="white"
          strokeWidth={0.2}
        />
      </g>
      <g filter="url(#filter1_f_418_1601)">
        <path
          d="M678 131.5L697.5 156.5L703.5 166L712 167L721.5 166L733 162.5H741H746.5C746.5 161.5 763.5 155.5 762.5 153.5C761.5 151.5 778 141.5 778 141V134.5L780 130.5V122.5C780 122.1 779 115 778.5 111.5L778 106L775 99L771 91L765.5 85.5L758.5 79L750.5 78H741H732.5H728L717 80L708.5 76.5L716.5 66.5L726.5 61H708.5H678V72V75.5L697 73.5L714.5 82V94L712 102L708 105L701.5 104H694L685 106L678 111.5V75.5V72V61H708.5H726.5H745L764.5 68L773 74L782.5 76L788.905 70.8759L793 61L790 70L788.905 70.8759L784.5 81.5C790.008 94.3459 791.699 101.821 793 115.5V170H764H678V131.5Z"
          fill="#FF7A33"
        />
        <path
          d="M746.5 162.5H741H733L721.5 166L712 167L703.5 166L697.5 156.5L678 131.5V170H764M746.5 162.5L758.5 168L764 170M746.5 162.5C746.5 163.3 763.5 166.833 764 170M746.5 162.5C746.5 161.5 763.5 155.5 762.5 153.5C761.5 151.5 778 141.5 778 141C778 140.6 778 136.5 778 134.5L780 130.5C780 128 780 122.9 780 122.5C780 122.1 779 115 778.5 111.5L778 106L775 99L771 91L765.5 85.5L758.5 79L750.5 78H741H732.5H728L717 80L708.5 76.5L716.5 66.5L726.5 61H708.5H678M764 170H793V115.5C791.699 101.821 790.008 94.3459 784.5 81.5L793 61L790 70L782.5 76L773 74L764.5 68L745 61H678M678 61V111.5L685 106L694 104H701.5L708 105L712 102L714.5 94V82L697 73.5L678 75.5V72V61Z"
          stroke="white"
          strokeWidth={0.2}
        />
      </g>
      <circle
        cx={736}
        cy={112}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={737}
        cy={115}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={734}
        cy={115}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={731}
        cy={114}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={729}
        cy={112}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={729}
        cy={109}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={729}
        cy={106}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={730}
        cy={103}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={732}
        cy={101}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={735}
        cy={99}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={738}
        cy={98}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={741}
        cy={98}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={744}
        cy={98}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={747}
        cy={99}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={750}
        cy={101}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={754}
        cy={104}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={757}
        cy={108}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={758}
        cy={111}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={759}
        cy={114}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={759}
        cy={117}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={759}
        cy={120}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={758}
        cy={123}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={756}
        cy={127}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={753}
        cy={131}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={751}
        cy={133}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={749}
        cy={135}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={747}
        cy={137}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={744}
        cy={138}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={740}
        cy={140}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={737}
        cy={141}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={734}
        cy={142}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={730}
        cy={142}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={727}
        cy={142}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={723}
        cy={141}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={720}
        cy={140}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={717}
        cy={138}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={714}
        cy={136}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={712}
        cy={134}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={710}
        cy={131}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={706}
        cy={125}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={704}
        cy={122}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={702}
        cy={117}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={701}
        cy={113}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={701}
        cy={109}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={701}
        cy={102}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={702}
        cy={98}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={703}
        cy={95}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={704}
        cy={92}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={706}
        cy={89}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={708}
        cy={86}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={710}
        cy={83}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={717}
        cy={77}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={722}
        cy={74}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={725}
        cy={72}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={728}
        cy={71}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={733}
        cy={70}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={736}
        cy={69}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={740}
        cy={69}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={754}
        cy={71}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={758}
        cy={72}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={761}
        cy={74}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={771}
        cy={81}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={780}
        cy={92}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={782}
        cy={95}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={784}
        cy={98}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={787}
        cy={110}
        r={1.1}
        fill="#FF7A33"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={738}
        cy={110}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={741}
        cy={110}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={743}
        cy={112}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={744}
        cy={115}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={744}
        cy={118}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={743}
        cy={121}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={741}
        cy={123}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={739}
        cy={125}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={736}
        cy={126}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={733}
        cy={127}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={730}
        cy={127}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={727}
        cy={126}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={724}
        cy={125}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={722}
        cy={123}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={720}
        cy={121}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={718}
        cy={118}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={717}
        cy={115}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={716}
        cy={112}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={716}
        cy={109}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={716}
        cy={106}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={717}
        cy={103}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={718}
        cy={100}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={720}
        cy={97}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={722}
        cy={94}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={724}
        cy={91}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={727}
        cy={88}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={730}
        cy={86}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={733}
        cy={85}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={736}
        cy={84}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={739}
        cy={84}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={743}
        cy={84}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={748}
        cy={85}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={751}
        cy={86}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={757}
        cy={89}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={760}
        cy={91}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={763}
        cy={93}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={766}
        cy={96}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={768}
        cy={99}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={769}
        cy={102}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={771}
        cy={116}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={771}
        cy={120}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={771}
        cy={124}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={770}
        cy={128}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={769}
        cy={132}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={768}
        cy={136}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={766}
        cy={140}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={758}
        cy={147}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={757}
        cy={148}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={752}
        cy={151}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={746}
        cy={154}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={740}
        cy={156}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={725}
        cy={156}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={721}
        cy={155}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={713}
        cy={151}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={711}
        cy={150}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={704}
        cy={146}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={702}
        cy={144}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={699}
        cy={140}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={697}
        cy={138}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={696}
        cy={137}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={694}
        cy={133}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={691}
        cy={128}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={690}
        cy={126}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={689}
        cy={123}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={688}
        cy={120}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={688}
        cy={117}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
      <circle
        cx={688}
        cy={114}
        r={1.1}
        fill="#2182DF"
        stroke="white"
        strokeWidth={0.2}
      />
    </g>
    <defs>
      <filter
        id="filter0_f_418_1601"
        x={689.895}
        y={89.6797}
        width={76.2051}
        height={62.4199}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={2}
          result="effect1_foregroundBlur_418_1601"
        />
      </filter>
      <filter
        id="filter1_f_418_1601"
        x={673.9}
        y={56.9004}
        width={123.199}
        height={117.199}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={2}
          result="effect1_foregroundBlur_418_1601"
        />
      </filter>
      <linearGradient
        id="paint0_linear_418_1601"
        x1={464.449}
        y1={68.7246}
        x2={449}
        y2={68.7246}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2182DF" />
        <stop offset={1} stopColor="#FF6600" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_418_1601"
        x1={517.49}
        y1={61}
        x2={517.49}
        y2={76.4492}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_418_1601"
        x1={578.256}
        y1={61}
        x2={578.256}
        y2={76.4492}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_418_1601"
        x1={639.021}
        y1={61}
        x2={639.021}
        y2={76.4492}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_418_1601"
        x1={639.021}
        y1={85.7168}
        x2={639.021}
        y2={101.166}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_418_1601"
        x1={639.021}
        y1={110.435}
        x2={639.021}
        y2={125.884}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_418_1601"
        x1={639.021}
        y1={135.154}
        x2={639.021}
        y2={150.604}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_418_1601"
        x1={637.478}
        y1={159.874}
        x2={637.478}
        y2={175.323}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_418_1601"
        x1={578.256}
        y1={85.7168}
        x2={578.256}
        y2={101.166}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_418_1601"
        x1={578.256}
        y1={110.435}
        x2={578.256}
        y2={125.884}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_418_1601"
        x1={578.256}
        y1={135.154}
        x2={578.256}
        y2={150.604}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_418_1601"
        x1={578.256}
        y1={159.874}
        x2={578.256}
        y2={175.323}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_418_1601"
        x1={578.256}
        y1={184.592}
        x2={578.256}
        y2={200.041}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_418_1601"
        x1={578.256}
        y1={209.312}
        x2={578.256}
        y2={224.762}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_418_1601"
        x1={578.256}
        y1={234.029}
        x2={578.256}
        y2={249.479}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_418_1601"
        x1={517.49}
        y1={85.7168}
        x2={517.49}
        y2={101.166}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_418_1601"
        x1={517.49}
        y1={110.435}
        x2={517.49}
        y2={125.884}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_418_1601"
        x1={517.49}
        y1={135.154}
        x2={517.49}
        y2={150.604}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_418_1601"
        x1={517.49}
        y1={159.874}
        x2={517.49}
        y2={175.323}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_418_1601"
        x1={517.49}
        y1={184.592}
        x2={517.49}
        y2={200.041}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_418_1601"
        x1={517.49}
        y1={209.312}
        x2={517.49}
        y2={224.762}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_418_1601"
        x1={517.49}
        y1={234.029}
        x2={517.49}
        y2={249.479}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#2182DF" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_418_1601"
        x1={456.725}
        y1={85.7168}
        x2={456.725}
        y2={101.166}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2182DF" />
        <stop offset={1} stopColor="#FF6600" />
      </linearGradient>
      <clipPath id="clip0_418_1601">
        <rect
          width={115}
          height={109}
          fill="white"
          transform="translate(678 61)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default ServiceCardNaturalLanguage;
